import toastr from 'toastr';

import { image as imageConfig, headerAndFooter, constants } from '@config';
import Store from '@store';
import { saveMetadata } from 'src/store/actions/metadata.action';
import { formatLinkedTextToMetadata } from 'src/store/actions/navigation.prepare';
import { logError, logInfo } from 'src/utils/logger';
import { clipPathCleanup } from 'src/utils/sanitize/clip-path';
import { sanitizeSavingContent } from 'src/utils/sanitize-content';
import { capitalizeFirstLetter } from 'src/utils/string';
import { uploadAsset } from 'src/utils/upload-image';

import { isDataURL } from '../helpers/dataUrl';
import { sanitizeIgnoredSaveTagsSvg, sanitizeIgnoredTagsSvg } from '../helpers/fixPageSvg';

export default () => {
  const toolBarOpenCloseTime = 500;
  /**
   * Singleton class
   */
  INKIVE.Tool = function (elem, editor, callback) {
    this.col = 2;
    this.$elem = elem
      ? $(elem)
      : $('#tool-panel');
    this.editor = editor;
    this.tabButtonTraker = null;

    this.timeout = {
      image: 5000
    };

    this.token = {
      facebook: null,
      instagram: null
    };

    const that = this;

    this.inkiveLoader(true, function () {
      const continueLoadingOnce = _.once(function () {
        callback && callback();
        setTimeout(continueLoading, 0);
      });

      $('#ik-editor').css('opacity', 0);
      typeof fontSpy === 'undefined' || fontSpy('Lato', { success: continueLoadingOnce });
      _.delay(continueLoadingOnce, 3000);

      function continueLoading () {
        that.initMainHandlers();

        INKIVE.Helpers.initTooltips();
        INKIVE.Helpers.initPopover();

        that.initAccordion();
        that.initDropdownButton();
        that.initExpandContent();
        that.initSidebarResizeButton();
        that.initTabEvent();

        INKIVE.C.IS_MOBILE && that.updateCurrentPageInfo();

        const ProjectFacade = require('../editor/facade/project/project');
        ProjectFacade.on('design.removed', function (data) {
          INKIVE.EditorFacade.handle('cache', 'remove', data);
          that.updateCurrentPageInfo();
        });

        // Init mobile menu
        INKIVE.C.IS_MOBILE && $('.tool-menu .menu .ui-dropdown').popupmenudropdown();

        // Default colors
        if (!localStorage.getItem('colors')) {
          _.each(INKIVE.C.DefaultColors, editor.setFavColor);
        }
      }
    });
  };

  // INKIVE.Tool._current_mode = 'default'; // layout, sticker, banner, placeholder
  // INKIVE.Tool._current_mode_data = null;
  INKIVE.Tool._current_page_number = null;
  INKIVE.Tool._cache = {};
  INKIVE.Tool._autoSaveTimeout = null;
  INKIVE.Tool._intervalThumb = {}; // list by element ID, for stickers and layouts

  INKIVE.Tool.preloadFavFonts = function (_callback) {
    _callback = _callback || $.noop;

    if (INKIVE.Tool._cache.favFonts) {
      _callback(true);
      return;
    }

    INKIVE.Helpers.api('favourites/font', 'GET', { id: INKIVE.C.BOOK.id }, function (r) {
      INKIVE.Tool._cache.favFonts = (r.data)
        ? r.data
        : [];

      _callback(r.status === 'success');
    });
  };

  INKIVE.Tool.preloadLayoutFormat = function (_callback) {
    _callback = _callback || $.noop;

    if (INKIVE.Tool._cache.layoutFormat) {
      _callback(true);
      return;
    }

    INKIVE.Helpers.api('management/layoutformat', 'GET', {}, function (r) {
      if (r.status === 'success') {
        INKIVE.Tool._cache.layoutFormat = r.data;
      }

      _callback(r.status === 'success');
    });
  };

  INKIVE.Tool.preloadStickerCategories = function (_callback) {
    _callback = _callback || $.noop;

    if (INKIVE.Tool._cache.stickerCategories) {
      _callback(true);
      return;
    }

    INKIVE.Helpers.api('search/category', 'GET', {
      type: 'sticker'
    }, function (categories) {
      INKIVE.Tool._cache.stickerCategories = categories;
      _callback(true);
    });
  };

  INKIVE.Tool.preloadBackgroundCategories = function (_callback) {
    _callback = _callback || $.noop;

    if (INKIVE.Tool._cache.backgroundCategories) {
      _callback(true);
      return;
    }

    INKIVE.Helpers.api('search/category', 'GET', {
      type: 'background'
    }, function (categories) {
      INKIVE.Tool._cache.backgroundCategories = categories;
      _callback(true);
    });
  };

  INKIVE.Tool.getInstance = function (elem, editor, callback) {
    if (!INKIVE.Tool.INSTANCE && editor) {
      INKIVE.Tool.INSTANCE = new INKIVE.Tool(elem, editor, callback);
    }

    return INKIVE.Tool.INSTANCE;
  };

  INKIVE.Tool.autoSave = function () {
    INKIVE.Tool._autoSaveTimeout && clearTimeout(INKIVE.Tool._autoSaveTimeout);
    INKIVE.Tool._autoSaveTimeout = null;

    const tool = INKIVE.Tool.getInstance();
    const canvas = tool.editor.canvas;

    const skipAutosave = canvas.getCurrentDrawing().getCurrentLayer().getAttribute('class') === 'clipperImage';

    if (skipAutosave) {
      return;
    }

    if (INKIVE.C.IS_AUTO_SAVE && INKIVE.Tool.getInstance() && !INKIVE.Tool._autoSaveTimeout) {
      INKIVE.Tool._autoSaveTimeout = setTimeout(function () {
        INKIVE.C.IS_DEV && console.warn('Autosave');
        INKIVE.EditorFacade.handle('page', 'save', { quiet: true })
          .then(function () { INKIVE.Tool._autoSaveTimeout = null; });
      }, INKIVE.C.AUTO_SAVE_INTERVAL);
    }
  };

  INKIVE.Tool.disableUI = function () {
    $('.tool-menu').addClass('disabled');
    $('.tool-content').addClass('disabled');
    $('header').addClass('disabled');
    $('#copy-paste-panel').addClass('disabled');
    $('#right-submenu').addClass('disabled');
    $('#left-submenu').addClass('disabled');
    $('#pages-panel').addClass('disabled');
  };

  INKIVE.Tool.enableUI = function () {
    $('.tool-menu').removeClass('disabled');
    $('.tool-content').removeClass('disabled');
    $('header').removeClass('disabled');
    $('#copy-paste-panel').removeClass('disabled');
    $('#right-submenu').removeClass('disabled');
    $('#left-submenu').removeClass('disabled');
    $('#pages-panel').removeClass('disabled');
  };

  INKIVE.Tool.blinkScreen = function (elem) {
    const $screen = elem
      ? $(elem)
      : $('#workarea');
    const backgroundColor = $($screen)[0].style.backgroundColor || 'transparent';

    $screen.animate({ backgroundColor: '#FFDD17' }, 100, function () {
      $screen.animate({ backgroundColor }, 500);
    });
  };

  INKIVE.Tool.calculateStringContentDifference = function (oldText, newText) {
    let start = 0;
    while (start < oldText.length && start < newText.length && oldText[start] === newText[start]) {
      start++;
    }

    let end = 0;
    while (end < oldText.length &&
      end < newText.length &&
      oldText.length - end > start &&
      newText.length - end > start &&
      oldText[oldText.length - 1 - end] === newText[newText.length - 1 - end]
    ) {
      end++;
    }

    const newStringEnd = newText.length - end;
    const oldStringEnd = oldText.length - end;

    const removed = oldStringEnd - start;
    const added = newStringEnd - start;

    return {
      position: start,
      removed,
      added
    };
  };

  INKIVE.Tool.prototype = {

    constructor: INKIVE.Tool,

    initMainHandlers: function () {
      INKIVE.C.IS_MOBILE && initToolBarLegacyHandlers();

      function initToolBarLegacyHandlers () {
        initPageNavButtons();
        initShareButtons();

        function initShareButtons () {
          $('#ik-share-link').on('click', function () {
            this.select();
          });

          $('#tabShare .notallowed .btn').on('click', function (event) {
            $('#ik-project-privacy a.make-public').trigger('click');
            event.stopPropagation();

            if (!INKIVE.C.IS_MOBILE) {
              const $button = $('#ik-share');
              const html = $button.html();

              $button.html(
                INKIVE.TemplatesHelper('modal_loader') +
                  '<span>hold on...</span>'
              );

              $button.one('click', function () {
                $button.html(html);
              });
            }
          });

          $('#ik-share-facebook').on('click', function () {
            share(INKIVE.Helpers.getTwitterUrl(), 'share_with_fb');
          });

          $('#ik-share-linkedin').on('click', function () {
            share(INKIVE.Helpers.getLinkedinUrl());
          });

          $('#ik-share-twitter').on('click', function () {
            share(INKIVE.Helpers.getTwitterUrl());
          });

          $('#ik-share-google').on('click', function () {
            share(INKIVE.Helpers.getGoogleplusUrl());
          });

          function share (url, appMethod) {
            let useAppHandledShareFlow = false;

            if (INKIVE.C.IS_MOBILE_APP && AppBridge.version.isApp('desygner')) {
              useAppHandledShareFlow = window.Android
                ? !appMethod && INKIVE.C.MODE.IS_DESYGNER && AppBridge.version.isGreaterThan('1.0.2')
                : ((INKIVE.C.MODE.IS_INKIVE && AppBridge.version.isGreaterThan('1.5.1')) ||
                  (INKIVE.C.MODE.IS_PHOTOBOOKY && AppBridge.version.isGreaterThan('1.2')) ||
                  (INKIVE.C.MODE.IS_DESYGNER && AppBridge.version.isGreaterThan('1.0.1')));
            }

            if (useAppHandledShareFlow) {
              AppBridge.callBoth(appMethod || 'open_in_new_window', { url });
            } else {
              const newWindow = window.open(url, 'Share', 'height=500,width=500, location=0');
              window.focus && newWindow.focus();
            }
          }

          $('#ik-share-embed').on('click', function () {
            const modalData = new INKIVE.ModalShareEmbed({});
            const modal = INKIVE.Modal.modalWindow(modalData.getFormHtml(), {
              width: 600,
              headerIcon: 'fa fa-code',
              headerTitle: 'editor.embed',
              buttons: [{
                title: 'close',
                onClick: function () {
                  modalData.saveForm(function () {
                    modal.close();
                  });
                }
              }]
            });
          });

          $('#ik-share-email').on('click', function () {
            const modalData = new INKIVE.ModalShareEmail();
            const modal = INKIVE.Modal.modalWindow(modalData.getFormHtml(), {
              width: 500,
              headerIcon: 'fa fa-mail-forward',
              headerTitle: 'modal.title.share_email',
              buttons: [{
                title: 'Send',
                onClick: function () {
                  modalData.saveForm(function () {
                    modal.close();
                  });
                }
              }]
            });
          });
        }

        function initPageNavButtons () {
          $('.action[data-action="delete_page"]').on('click', function () {
            INKIVE.ProjectFacade.handle('design', 'delete', { quiet: true });
          });

          $('.action[data-action="go_previous_page"]').on('click', function () {
            INKIVE.EditorFacade.handle('page', 'move_to', {
              page_number: INKIVE.Tool._current_page_number - 1,
              quiet: true
            });
          });

          $('.action[data-action="go_next_page"]').on('click', function () {
            INKIVE.EditorFacade.handle('page', 'move_to', {
              page_number: INKIVE.Tool._current_page_number + 1,
              quiet: true
            });
          });

          $('.action[data-action="add_page"]').on('click', function () {
            INKIVE.ProjectFacade.handle('design', 'add', {
              quiet: true,
              silent: true
            });
          });
        }
      }

      // Disable some basic stuff
      $(window).on('contextmenu', function (e) {
        const $target = $(e.target);

        if ($target.is('.context-menu-enabled')) {
          $target.select();
        } else {
          return false;
        }
      });

      $(window).on('dragstart', function (e) {
        /**
         * TODO: we should not be disabling the behavior and whitelisting exceptions
         * Instead, this should be removed entirely, and events attach/detach on a relevant lifecycle
         */
        return !!e?.target?.closest('#text-overflow-mount-point');
      });

      $('#help').on('click', function () {
        const help = new INKIVE.ModalHelp({});
        const modal = INKIVE.Modal.modalWindow(help.getFormHtml(), {
          width: 500,
          headerIcon: 'desygner-icon-question-mark',
          headerTitle: 'general.help',
          buttons: [{
            title: INKIVE.TranslateHelper.translate('modal.buttons.send_request'),
            onClick: function () {
              INKIVE.Modal.togglePageLoader(true);
              help.saveForm(function () {
                modal.close();
                INKIVE.Modal.togglePageLoader(false);
              });
            }
          }]
        });
      });
    },

    initAccordion: function () {
      const that = this;

      // Init accordion
      $('.accordion > dt > [data-toggle!="tab"][data-toggle!="custom"]').on('click', function () {
        $('.accordion > dt > [data-toggle!="tab"][data-toggle!="custom"]').each(function (index, elem) {
          const $target = $(elem).parent().next();
          if ($target.length) $target.slideUp('fast');
        });

        const $elem = $(this);
        if (!$elem.hasClass('active')) {
          const $target = $elem.parent().next();
          if ($target.length) {
            if ($elem.attr('data-toggle') === 'accordion') {
              that.initTab($elem.attr('href'), function (boolen) {});
            }

            $target.slideDown('fast', function () {
              const $acc = $elem.attr('href');
              $($acc).reloadThumb();
              that.initScroll($acc);
            });
          }

          $('.accordion > dt > [data-toggle!="custom"]').removeClass('active');
          $elem.addClass('active');
        } else {
          $('.accordion > dt > [data-toggle!="custom"]').removeClass('active');
        }

        return false;
      });
    },

    initExpandContent: function () {
      $('.expand-panel .expand-button').on('click', function () {
        const $content = $(this).parents('.expand-panel').find('.expand-content');
        const $i = $(this).find('i');
        const $icon = $(this).find('icon');

        if ($content.is(':visible')) {
          $i.attr('class', 'icon-chevron-right');
          $icon.css('transform', 'rotate(0deg)');
          $(this).removeClass('active');
        } else {
          $i.attr('class', 'icon-chevron-down');
          $icon.css('transform', 'rotate(-180deg)');
          $(this).addClass('active');
        }

        $content.slideToggle('fast');
      });
    },

    setImageEventsListener: function () {
      const imageAddEvents = [
        'image.replace',
        'image.create.optimize_resolution',
        'image.create.resize_external',
        'image.update.optimize_resolution',
        'image.update.resize_external',
        'background.update.updating_source'
      ];

      const imageDoneEvents = [
        'image.replace.skip',
        'image.create.source.url',
        'image.create.optimus_resolution',
        'image.update.source.url',
        'image.update.optimus_resolution',
        'background.update.source'
      ];

      for (const event of imageAddEvents) {
        INKIVE.DesignFacade.on(event, () => {
          $('.ui-dropdown-button').addClass('disabled');
          setTimeout(() => {
            $('.ui-dropdown-button').removeClass('disabled');
          }, 15000);
        });
      }

      for (const event of imageDoneEvents) {
        INKIVE.DesignFacade.on(event, () => {
          $('.ui-dropdown-button').removeClass('disabled');
        });
      }
    },

    initDropdownButton: function () {
      this.setImageEventsListener();

      $('.ui-dropdown-button').on('click', async function (e, isOnLoadEvent) {
        const id = $(this).attr('data-id');

        if (!isOnLoadEvent && ['share', 'order-print', 'download'].includes(id)) {
          const company = await INKIVE.CompanyFactory.getCompanyData();
          const actionsBlocked = company.is_customisation_preview;

          if (actionsBlocked) {
            e.stopPropagation();
            e.preventDefault();
            INKIVE.Helpers.displaySubscriptionModal(null, constants.plans.proTeam, true, company.domain);
            return;
          }
        }

        const right = Math.round($(window).width() - $(this).offset().left - ($(this).width() + 30));
        const $elem = $('.ui-dropdown-content[data-id="' + id + '"]');

        $elem.css('right', right);
        $elem.fadeToggle('fast');

        $(this).toggleClass('active');
      });

      // top menu
      $(document).on('mousedown', function (e) {
        this.tool = INKIVE.Tool.getInstance();
        const container = $('.ui-dropdown-content');
        const upgradeModalShown = $('.payment-modal').find('access').is(':not(.aurelia-hide)');
        const loaderShown = $(e.target).parents('*').andSelf().filter('.modalWrapper.overlay').length;
        const dialogOpen = !!document.querySelector('body.ux-dialog-open');

        $(document.activeElement).is('body,textarea#text,textarea#text-overflow-textarea') || document.activeElement.blur();

        if ($(e.target).closest('.ui-dropdown-button.active').length || upgradeModalShown || loaderShown || dialogOpen) {
          return;
        }

        if (!container.is(e.target) && container.has(e.target).length === 0) {
          container.fadeOut('fast');

          if (container.find('input[name="includeManualBleed"]').is(':checked')) {
            this.tool.editor.canvas.runExtensions('hideBleedClipper', { keepDisabled: false });
            this.tool.editor.canvas.runExtensions('disableGuideLine', { keepVisible: false });
            $('.filter-bleed-type').addClass('hidden');
          }

          $('.ui-dropdown-button').each(function () {
            $(this).is('.forced') || $(this).removeClass('active');
            $('.ui-dropdown-button').blur();
          });
        }
      });

      // popup menu
      $(document).mouseup(function (e) {
        const container = $('.ui-dropdown-items');
        const upgradeModalShown = $('.payment-modal').find('access').is(':not(.aurelia-hide)');
        const loaderShown = $(e.target).parents('*').andSelf().filter('.modalWrapper.overlay').length;
        const colorPickerShown = $(e.target).parents('*').andSelf().filter('#jpickerWrapper.addmore-color-picker').length;

        if ($(e.target).closest('.ui-dropdown-button.active').length || upgradeModalShown || loaderShown || colorPickerShown) return;

        if (!container.is(e.target) && container.has(e.target).length === 0) {
          container.each(function () {
            const isRootButton = $(this).parents('.root-popupmenu').length;
            isRootButton && $(this).css('visibility', 'hidden');
            isRootButton || $(this).fadeOut('fast');
          });

          const $activeDropdown = $('.ui-dropdown.active');

          if ($activeDropdown.length) {
            INKIVE.EditorFacade.trigger('element.menu.dropdown', {
              show: false,
              action: $activeDropdown.attr('data-action'),
              type: $activeDropdown.attr('type')
            });
            $('#sidebar-resize-button').removeClass('collapse-hidden', $('#font-menu-list').is(':visible'));
            $activeDropdown.removeClass('active');
          }

          const visibleDropdowns = document.querySelector('.stroke-dropdown.visible');
          visibleDropdowns && visibleDropdowns.classList.remove('visible');
        }
      });
    },

    initSidebarResizeButton: function () {
      const toolPanel = $('#tool-panel');

      function updateWorkingArea () {
        // get the work are container and div values (width).
        const editorCanvasSize = document.querySelector('#ik-editor').getBoundingClientRect();
        const workAreaStyle = document.querySelector('#workarea').style;
        const workCanvas = INKIVE.Tool.getInstance().editor.canvas;
        // adapt the size of the #workarea before refreshing the zoom.
        workAreaStyle.width = editorCanvasSize.width + 'px';
        workAreaStyle.height = editorCanvasSize.height + 'px';

        // updates the antiscroll
        workCanvas.setZoom(workCanvas.getZoom());
        $('#ik-editor').antiscroll();
      }

      function updateElementPopupMenu (toolContentWidth) {
        const elementPopupMenu = document.querySelector('.element-popupmenu');
        const leftArrow = elementPopupMenu.parentElement.querySelector('.scroll-handler-left');
        const currentLeft = parseInt(window.getComputedStyle(elementPopupMenu).left);
        const end = elementPopupMenu.parentElement.clientWidth - elementPopupMenu.clientWidth;
        const editor = INKIVE.Tool.getInstance().editor;

        if (currentLeft < end) {
          elementPopupMenu.style.left = `${end}px`;
          editor.canvas.runExtensions('browserResize', {
            skipScroll: true,
            $handler: $(leftArrow)
          });
        }
      }

      function updateHandlers () {
        const elementPopupMenu = document.querySelector('.element-popupmenu');
        const currentLeft = parseInt(window.getComputedStyle(elementPopupMenu).left);
        const end = elementPopupMenu.parentElement.clientWidth - elementPopupMenu.clientWidth;
        const editor = INKIVE.Tool.getInstance().editor;
        currentLeft > end && editor.canvas.runExtensions('browserResize', {
          skipScroll: true,
          showBoth: true
        });
      }

      function triggerResize (newWidth) {
        $('#element-popupmenu').css('left', newWidth);
        $('#sidebar-resize-button').css({ left: newWidth });
      }

      function updateWidth (newWidth) {
        toolPanel.width(newWidth);
        triggerResize(newWidth);
      }

      function closePanel () {
        const toolMenuWidth = $('.tool-menu').width();
        const toolContentWidth = $('.tool-content').width();
        const resizeButton = $('#sidebar-resize-button');
        resizeButton
          .css({ left: toolMenuWidth });
        toolPanel.addClass('on-animate');
        const newWidth = toolPanel.width() - toolContentWidth;
        INKIVE.EditorFacade.trigger('sidebarpanel.toggle', newWidth);
        toolPanel.addClass('collapsed');
        updateWidth(newWidth);
        $('#tool-panel .tool-menu li.active').removeClass('active');

        setTimeout(() => {
          toolPanel.removeClass('on-animate');
          updateWorkingArea();
          updateElementPopupMenu(toolContentWidth);
        }, toolBarOpenCloseTime);
      }

      function openPanel () {
        if (!toolPanel.hasClass('collapsed')) return;

        const toolMenuWidth = $('.tool-menu').outerWidth();
        const toolContentWidth = $('.tool-content').width();
        const newWidth = toolMenuWidth + toolContentWidth;
        INKIVE.EditorFacade.trigger('sidebarpanel.toggle', newWidth);
        toolPanel.addClass('on-animate').removeClass('collapsed');
        toolPanel.width() === newWidth || updateWidth(newWidth);

        setTimeout(() => {
          toolPanel.removeClass('on-animate');
          updateWorkingArea();
          updateHandlers();
        }, toolBarOpenCloseTime);
      }

      toolPanel.find('[data-toggle="tab"]').on('shown.bs.tab', openPanel);
      $('#tool-panel #sidebar-resize-button').on('click', closePanel);
      $(document).on('sidebarpanel.show', openPanel);
      $(document).on('sidebarpanel.collapse', closePanel);
    },

    // Make a copy for now
    download: function (format) {
      console.log('download');
      const that = this;
      const editor = that.editor;
      const svgCanvas = editor.canvas;

      const alert = INKIVE.Modal.alertMessage(INKIVE.TemplatesHelper('alert_bold', {
        message: 'modal.alert.preparing_file'
      }), {
        skip: false,
        loader: true
      });

      const $wrapper = $('.ui-dropdown-content[data-id="download"] div[data-type="' + format + '"]');
      const $webQualityCheckbox = $wrapper.find('[name=is' + (format === 'jpeg'
        ? 'Jpg'
        : 'Png') + 'WebQuality]');

      $('.ui-dropdown-button[data-id="download"]').click();

      if ($webQualityCheckbox.length && $webQualityCheckbox[0].checked) {
        const timeStamp = Date.now();
        const canvasBackground = format === 'png' && $wrapper.find('[name=isForcedTransparency]').is(':checked')
          ? null
          : '#FFFFFF';
        const quality = format === 'jpeg'
          ? $wrapper.find('.quality-slider').slider('value')
          : null;
        let isDownloaded = false;

        INKIVE.DesignFacade.off('preview.download').on('preview.download', function (base64ImageData) {
          if (isDownloaded) return;

          const fileName = Base64.decode(INKIVE.C.BOOK.name) + '.' + format.replace('jpeg', 'jpg');

          if (navigator.msSaveBlob) {
            const b64toBlob = function (b64Data, contentType, sliceSize) {
              contentType = contentType || '';
              sliceSize = sliceSize || 512;

              const byteCharacters = atob(b64Data);
              const byteArrays = [];

              for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                const slice = byteCharacters.slice(offset, offset + sliceSize);

                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                  byteNumbers[i] = slice.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
              }

              return new Blob(byteArrays, { type: contentType });
            };

            const imageData = base64ImageData.split(';base64,');
            const blob = b64toBlob(imageData[1], imageData[0].replace('data:', ''));

            navigator.msSaveBlob(blob, fileName);
          } else {
            const link = document.createElement('a');
            link.download = fileName;

            link.href = base64ImageData.replace('image/' + format, 'image/octet-stream');

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }

          Date.now() - timeStamp > 1000
            ? alert.close()
            : _.delay(_.bind(alert.close, alert), 1000);
          isDownloaded = true;
        });

        INKIVE.DesignFacade.handle('preview', null, {
          maxwidth: svgCanvas.contentW,
          maxheight: svgCanvas.contentH,
          format,
          background: canvasBackground,
          isdownload: true,
          quality
        });

        _.delay(function () {
          if (!isDownloaded) {
            isDownloaded = true;
            alert.close();

            $webQualityCheckbox[0].checked = false;
            $webQualityCheckbox.closest('.icheckbox_square-yellow').removeClass('checked');
            $webQualityCheckbox.closest('.checkbox').addClass('disabled');
            $webQualityCheckbox.trigger('change');

            INKIVE.Modal.alertMessage(
              INKIVE.TemplatesHelper('alert_span', {
                text: INKIVE.TranslateHelper.translate('modal.alert.downloading_web_error')
              })
            );
          }
        }, 10000);
      } else {
        INKIVE.EditorFacade.handle('page', 'save').then(function () {
          INKIVE.Helpers.DownloadProcedure.execute($wrapper, {
            contentW: svgCanvas.contentW,
            contentH: svgCanvas.contentH,
            format
          }, function () {
            alert.close();
          });
        }, function () {
          alert.close();
        });
      }
    },

    initDownload: function () {
      const $panel = $('.ui-dropdown-content[data-id="download"]');

      if (!$panel.length) {
        return;
      }

      const that = this;
      const editor = that.editor;
      const svgCanvas = editor.canvas;

      // Init tabs
      $panel.find('.tabs').tabs();

      const dimensions = ['thumb', 'web', 'mobile'];
      let width = svgCanvas.contentW;
      let height = svgCanvas.contentH;

      // Special case, to make 72dpi
      if (width === 737 && height === 521) {
        width = 842;
        height = 595;
      }

      const aspect = width / height;

      const slider = $panel.find('.quality-slider').slider({
        max: 100,
        min: 1,
        value: 92,
        slide: function (event, ui) {
          $panel.find('div[data-type="jpeg"] .estimated-size .value')
            .html(INKIVE.Helpers.calculateJpegSize(width, height, ui.value));
        },
        start: function (event, ui) {
        },
        stop: function (event, ui) {
        }
      });
      slider.slider('float');

      initCheckbox();

      setDefaultValues('rangeCurrent');
      setDefaultValues('thumb', 110);
      setDefaultValues('mobile', 600);
      setDefaultValues('web', 800);

      setWebQuality(true);

      _.each(dimensions, setOnToggled);
      _.each(_.union(['rangeCurrent'], dimensions), setOnChange);

      $panel.find('div[data-type="png"] .estimated-size .value').html(INKIVE.Helpers.calculatePngSize(width, height));
      $panel.find('div[data-type="jpeg"] .estimated-size .value')
        .html(INKIVE.Helpers.calculateJpegSize(width, height, $panel.find('.quality-slider').slider('option', 'value')));

      INKIVE.C.BOOK.num_pages === 1 && $panel.find('[type=radio][name="isRange"][id="isRangeCurrent"]')
        .parents('div.checkbox').hide();
      INKIVE.C.BOOK.num_pages === 1 && $panel.find('[type=radio][name="isRange"][id="isRangeSelected"]')
        .parents('div.checkbox').hide();

      $panel.find('[type=radio][name="isRange"]').off('change').on('change', function () {
        if ($(this).is(':checked')) {
          $panel.find('.ui-dropdown, .rangeCurrentDimensions').addClass('disabled');

          if ($(this).attr('id') === 'isRangeSelected') {
            $panel.find('.ui-dropdown').removeClass('disabled');
          } else if ($(this).attr('id') === 'isRangeCurrent') {
            $panel.find('.rangeCurrentDimensions').removeClass('disabled');
            setPageRange(INKIVE.Tool._current_page_number, INKIVE.Tool._current_page_number);
          } else {
            setPageRange(1, INKIVE.C.BOOK.num_pages);
          }
        }
      });

      setPageRangeDropdown();

      $panel.find('.select-dropdown').off('change').on('change', function () {
        const $from = $panel.find('select#page_from_options');
        const $to = $panel.find('select#page_to_options');
        const from = parseInt($from.val());
        const to = parseInt($to.val());

        $from.is(this)
          ? from >= to && $to.val(from)
          : to <= from && $to.val(from);
      });

      if ($panel.find('[type=radio][name="isRange"][id="isRangeAll"]').is(':checked')) {
        setPageRange(1, INKIVE.C.BOOK.num_pages);
      }

      const $bleedCheckmarks = $panel.find('[name=isAutomaticBleed], [name=isBleed]');

      $bleedCheckmarks.on('change', function () {
        const checked = this.checked;

        $bleedCheckmarks.attr('checked', false);
        this.checked = checked;
      });

      INKIVE.DesignHandler.on('added removed', setPageRangeDropdown);

      function setPageRange (from, to) {
        $panel.find('#page_from_options').val(from);
        $panel.find('#page_to_options').val(to);
      }

      function setPageRangeDropdown () {
        const $from = $panel.find('select#page_from_options').empty();
        const $to = $panel.find('select#page_to_options').empty();

        for (let i = 1, len = INKIVE.C.BOOK.num_pages; i <= len; i++) {
          const element = $.parseHTML('<option data-id="' + i + '">' + i + '</option>');
          $from.append($(element).clone());
          $to.append($(element).clone());
        }

        setPageRange(1, INKIVE.C.BOOK.num_pages);
      }

      function initCheckbox () {
        $panel.find('.ui-dropdown .input-icon').off('click').on('click', function (event) {
          $(event.target).parents('.ui-dropdown').find('ul').toggle();
        });

        $panel.find('a.quality').off('click').on('click', function () {
          $panel.find('a.quality').removeClass('active');
          $(this).addClass('active');
        });
      }

      function setDefaultValues (name, limit) {
        const className = '.' + name + 'Dimensions';

        const thisWidth = limit && width > limit
          ? limit
          : width;

        const thisHeight = limit && width > limit
          ? parseInt((limit / aspect) + '')
          : height;

        $panel.find(className + '[data-type="width"]').val(thisWidth);
        $panel.find(className + '[data-type="height"]').val(thisHeight);
      }

      function setWebQuality (isFirstLoad) {
        const tool = INKIVE.Tool.getInstance();
        const canvas = tool.editor.canvas;

        const checkBoxes = $('[type=checkbox][name="isJpgWebQuality"], [type=checkbox][name="isPngWebQuality"]');

        checkBoxes.on('change', function () {
          const $panel = $(this).closest('.ui-tabs-panel');
          const $qualitySlider = $panel.find('.quality-slider');

          $panel.find('.expand-panel').toggleClass('disabled', this.checked);

          if ($qualitySlider.length) {
            const qualityValue = this.checked
              ? 60
              : 91;

            $qualitySlider.slider({ value: qualityValue });
            $qualitySlider.toggleClass('disabled', this.checked);
            $panel.find(' .estimated-size .value')
              .html(INKIVE.Helpers.calculateJpegSize(canvas.contentW, canvas.contentH, qualityValue));
          }
        });

        isFirstLoad && checkBoxes.trigger('change');
      }

      function setOnToggled (name) {
        const attName = 'is' + capitalizeFirstLetter(name);
        const className = '.' + name + 'Dimensions';

        $panel.find('[type=checkbox][name="' + attName + '"]').on('change', function () {
          $(this).parents('p').find(className).toggleClass('disabled');
        });
      }

      function setOnChange (name) {
        name += 'Dimensions';
        $panel.find('.' + name).change(function () {
          updateSize($(this), name);
        });
      }

      function updateSize ($elem, clazz) {
        let val = parseInt($elem.val());
        const type = $elem.attr('data-type');

        if (val < 16) val = 16;
        if (val > 3000) val = 3000;

        const width = type === 'width'
          ? val
          : parseInt(val / aspect);
        const height = type !== 'width'
          ? val
          : parseInt(val / aspect);

        $panel.find('.' + clazz + '[data-type="width"]').val(width);
        $panel.find('.' + clazz + '[data-type="height"]').val(height);
      }
    },

    initTabEvent: function (elem) {
      const that = this;
      elem = elem || 'body';

      $(elem).find('[data-toggle="tab"]').on('shown.bs.tab', function (event) {
        const $target = $(event.target);
        that.mobileBackMenu($target);
        that.tabButtonTraker = this;

        _.defer(initTab);
        INKIVE.C.IS_MOBILE && that.mobileBackMenuShow(true);

        function initTab () {
          const target = $target.attr('href');
          that.initTab(target, function (boolen) {
            boolen && that.initScroll(target);
          });
        }
      });
    },

    mobileBackMenu: function ($elem) {
      const $backMenu = $('#ik-menu-back');
      if (!$backMenu.length) return;

      const $text = $backMenu.find('.text-element');
      let parentText = 'Main menu';
      let parentHref = '';

      if ($elem && $elem.length) {
        const href = $elem.attr('href').replace('#', '');

        parentHref = $('[data-toggle="tab"][href="#' + href + '"]').parents('[role="tabpanel"]').attr('id') || parentHref;

        // special case for some tabs
        if ($.inArray(parentHref, ['tabPhotoAlbums', 'tabPhotoImages']) > -1) {
          parentHref = 'tabImages';
        }

        const $parent = $('[role="tab"][href="#' + parentHref + '"]');
        parentText = $parent.attr('tag') || parentText;
      }

      $backMenu.attr('data-href', parentHref);
      $text.html('Back to ' + parentText);
    },

    mobileBackMenuShow: function (isShow) {
      const $toolPanel = $('#tool-panel');

      isShow && $toolPanel.addClass('active');
      isShow || $toolPanel.removeClass('active');
    },

    initScroll: function (target, options) {
      const $target = $(target);
      const $activeAccordion = $target.find('.accordion dd:visible');

      const hasActiveAccordion = $activeAccordion.length;
      const isSpecialAccordion = $target.length &&
        $target.prop('tagName').toLowerCase() === 'dd';

      if (!isSpecialAccordion && hasActiveAccordion) {
        return this.initScroll($activeAccordion, options);
      }

      const width = $target.width() < $target.parents('.tool-content').width()
        ? $target.width()
        : $target.parents('.tool-content').width();

      options = $.extend({
        autoHide: false,
        width,
        height: getTabHeight()
      }, options);

      $target.hasClass('antiscroll-wrap')
        ? $target.antiscroll(options)
        : $target.find('.antiscroll-wrap:not(.no-resizable)').antiscroll(options);

      function getTabHeight () {
        const $tabPanel = $target.closest('div[role="tabpanel"]');
        let height = $tabPanel.height();

        const contentSelectors = [
          '.breadcrumb',
          '.tool-search',
          '.drag-drop-file',
          '.colorLineWrapper',
          '.tool-static-block',
          '.filterWrapper:not(.subfilter)',
          '.header-links',
          '.search-container',
          '.search-title'
        ];

        $tabPanel.find(contentSelectors.join(','))
          .filter(':visible')
          .filter(notInScroller)
          .each(function (index, value) {
            height -= $(value).outerHeight(true);
          });

        isSpecialAccordion && applyAccordionFix();

        return height;

        function notInScroller () {
          const $scroller = $(this).closest('.antiscroll-inner');
          return $scroller.length === 0;
        }

        function applyAccordionFix () {
          height -= 30;
          $target.parent('.accordion').find('dt').each(function () {
            height -= $(this).outerHeight(true);
          });
        }
      }
    },

    saveNotification: function (isSaving) {
      $('#ik-save').toggle(!isSaving);
      $('#ik-save-notification').toggle(isSaving);
    },

    updateCurrentPageInfo: function () {
      if (INKIVE.C.IS_MOBILE) {
        $('#current-page').html(INKIVE.Tool._current_page_number);
        $('#all-page').html(INKIVE.C.BOOK.num_pages);

        if (INKIVE.Tool._current_page_number === 1) {
          $('.action[data-action="go_previous_page"]').addClass('disabled');
        } else {
          $('.action[data-action="go_previous_page"]').removeClass('disabled');
        }

        if (INKIVE.Tool._current_page_number === INKIVE.C.BOOK.num_pages) {
          if (INKIVE.C.IS_MOBILE) {
            $('.action[data-action="go_next_page"]').hide();
            $('.action[data-action="add_page"]').show();
          } else {
            $('.action[data-action="go_next_page"]').addClass('disabled');
          }
        } else if (INKIVE.C.IS_MOBILE) {
          $('.action[data-action="go_next_page"]').show();
          $('.action[data-action="add_page"]').hide();
        } else {
          $('.action[data-action="go_next_page"]').removeClass('disabled');
        }

        if (INKIVE.C.BOOK.num_pages === 1) {
          $('.action[data-action="delete_page"]').addClass('disabled');
        } else {
          $('.action[data-action="delete_page"]').removeClass('disabled');
        }
      }
    },

    saveLayout: function (layout, _callback) {
      const that = this;
      const editor = that.editor;
      _callback = _callback || $.noop;
      const rootNode = $('#svgcontent');
      const mainNode = $('g.main');

      const title = $('g.main title');
      title.remove();
      const layoutData = mainNode.html();
      mainNode.prepend(title);
      let layoutDefs = $('#layout_defs').html();
      if (!layoutDefs) layoutDefs = '';

      let layoutBg = '';
      let svgCont = '';
      const backgroundContainer = rootNode.find('.background').get(0);

      if (layout.isBackground) {
        if (backgroundContainer) {
          layoutBg = backgroundContainer.innerHTML;
        }
        svgCont = editor.getSvgString();
      } else {
        rootNode[0].removeChild(backgroundContainer);
        svgCont = editor.getSvgString();
        rootNode[0].appendChild(backgroundContainer);
      }

      let svgDefs = $('<div>').append($($('#defsWrapper').find('defs')).clone()).html();
      if (!svgDefs) svgDefs = '<defs></defs>';

      try {
        processOriginalImageSizes();
      } catch (e) {
        console.error(e.message);
      }

      const params = {
        id: layout.id,
        layoutData: Base64.encode(layoutData),
        layoutDefs: Base64.encode(layoutDefs),
        layoutBg: Base64.encode(layoutBg),
        svgCont: Base64.encode(svgCont),
        svgDefs: Base64.encode(svgDefs)
      };

      _.delay(function () {
        INKIVE.Helpers.apiMultipart('management/layoutdata', params, function (r) {
          if (r && r.status === 'success') {
            _callback(true);
            that.updateThumbImage('layout-' + layout.id, r.url);
          } else {
            INKIVE.Modal.alertMessage(INKIVE.TemplatesHelper('alert_default', {
              message: 'modal.alert.update_layout'
            }));
            _callback(false);
          }
        });
      }, 1000);

      function processOriginalImageSizes () {
        const SVGImageRegexp = /(<image[^>]*\sxlink:href=['"])([^'"]*)(['"][^>]*>)/gi;
        svgCont = svgCont.replace(SVGImageRegexp, function (str, prev, url, next) {
          const decodedUrl = svgedit.utilities.fromXml(url);
          const originalImageUrl = INKIVE.ImagesFactory.getOriginalUrl(decodedUrl);

          url = originalImageUrl
            ? svgedit.utilities.toXml(originalImageUrl)
            : url;

          return prev + url + next;
        });
      }
    },

    saveSticker: function (sticker, _callback) {
      const that = this;
      _callback = _callback || $.noop;

      const data = INKIVE.Helpers.getStickerFromSvg();
      if (!data) {
        _callback(true);
        return;
      }

      const params = {
        id: sticker.id,
        content: Base64.encode(data)
      };

      INKIVE.Helpers.api('management/stickerdata', 'POST', params, function (r) {
        if (r && r.status === 'success') {
          _callback(true);
          that.updateThumbImage('sticker-' + r.id, r.url);
        } else {
          INKIVE.Modal.alertMessage(INKIVE.TemplatesHelper('alert_default', {
            message: 'modal.alert.update_sticker'
          }));
          _callback(false);
        }
      });
    },

    isReadyToSave: function () {
      return this.onceItsReadyToSave($.noop, $.noop, true);
    },

    onceItsReadyToSave: function (success, error, isSyncCheck) {
      const canvas = this.editor.canvas;
      const additionalSaves = {};
      const currentLayer = canvas.getCurrentDrawing().getCurrentLayer();
      const $svgRoot = $('#svgroot');
      const imagesArray = $svgRoot.find('.main image.element');
      const backgroundImage = document.querySelector('#svgroot .background image');
      INKIVE.ContextMenu.destroyMenu();

      isSyncCheck || $(`#svgcontent > g:not(.background,.${headerAndFooter.main.class},.main)`).remove();

      if (imagesArray.hasClass('drag-and-drop-upload')) {
        canvas.call('advice.show', 'uploading-images-save');
        error();
        return;
      }

      if (currentLayer && currentLayer.getAttribute('class') === 'clipperImage') {
        error();
        return;
      }

      INKIVE.Tool.uploadedImageData = INKIVE.Tool.uploadedImageData || {};

      backgroundImage && imagesArray.push(backgroundImage);

      for (let i = 0; i < imagesArray.length; i++) {
        const image = imagesArray[i];
        const hasInvalidSource = image.getAttribute('xlink:href') === 'null';
        if (hasInvalidSource) {
          image.remove();
          continue;
        }
        const imageHash = checkDataHash(image);

        const staticLink = INKIVE.Tool.uploadedImageData[imageHash];
        staticLink && svgedit.utilities.assignAttributes(image, { 'xlink:href': staticLink });
      }

      const hasImagesToLoad = _.any($.merge(imagesArray, $svgRoot.find('.background image')), checkImage);

      if (isSyncCheck) return !hasImagesToLoad;
      Object.keys(additionalSaves).length || success();

      function checkImage (image) {
        const url = image.getAttribute('xlink:href');
        const originalUrl = INKIVE.ImagesFactory.getImageUrl(image);

        if (!originalUrl && isDataURL(url)) {
          if (isSyncCheck) return true;

          const imageDataHash = image.getAttribute('data-hash');
          if (INKIVE.Tool.uploadedImageData[imageDataHash]) {
            waitUntilUploaded(image);
          } else {
            // For newly uploaded images, remove flip flags (as those flags are applied to data-url)
            image.classList.remove(INKIVE.C.FLIP_IMAGE.HORIZONTAL);
            image.classList.remove(INKIVE.C.FLIP_IMAGE.VERTICAL);

            INKIVE.Tool.uploadedImageData[imageDataHash] = 'pending';
            uploadBlobImage(INKIVE.Helpers.dataURLToBlob(url), image);
          }
        }
      }

      function resaveDefault (id) {
        if (additionalSaves[id]) {
          delete additionalSaves[id];
          Object.keys(additionalSaves).length || success();
        }
      }

      function waitUntilUploaded (image) {
        const id = image.getAttribute('id') || 'background';
        additionalSaves[id] = image.getAttribute('data-hash');
        const eventName = $(image).parent().is('.background')
          ? 'background.update.source'
          : id + '.source.url';

        INKIVE.DesignFacade.on(eventName, _.partial(resaveDefault, id));
      }

      function uploadBlobImage (blob, image, attempts = 2) {
        const imageName = INKIVE.Math.generateUUID();
        additionalSaves[imageName] = image.getAttribute('data-hash');

        const mimeType = image.getAttribute('xlink:href').includes('image/jpeg') ? 'image/jpeg' : 'image/png';

        uploadAsset(blob, imageName, mimeType, 'image')
          .then(({ url }) => {
            if (additionalSaves[imageName]) {
              const dataHash = additionalSaves[imageName];

              INKIVE.Tool.uploadedImageData[dataHash] = url;

              for (let i = 0; i < imagesArray.length; i++) {
                const img = imagesArray[i];
                if (dataHash === img.getAttribute('data-hash')) {
                  svgedit.utilities.assignAttributes(img, { 'xlink:href': url });
                  resaveDefault(img.id);
                }
              }
            }

            resaveDefault(imageName);

            return url;
          })
          .catch(() => {
            const dataHash = additionalSaves[imageName];

            INKIVE.Tool.uploadedImageData[dataHash] = undefined;

            resaveDefault(imageName);
          });
      }

      function checkDataHash (img) {
        const imageDataHash = img.dataset.hash;
        if (imageDataHash) return imageDataHash;

        const dataHash = INKIVE.ImagesFactory.getImageDataHash(img);
        img.setAttribute('data-hash', dataHash);

        return dataHash;
      }
    },

    getSaveString: function () {
      const svgContent = this.editor.getSvgString();

      return sanitizeSavingContent(svgContent);
    },

    savePage: function (quiet, _callback, returnString, additionalProps) {
      if (!INKIVE.Tool._current_page_number) {
        console.error('Calling page save on no page');
        _callback(true);
        return;
      }

      const editor = this.editor;

      INKIVE.C.IS_MOBILE_APP && !quiet && INKIVE.Modal.togglePageLoader(true);

      this.onceItsReadyToSave(_savePage, _.partial(_callback, true));

      function _savePage () {
        logSaveError();

        const svgContent = sanitizeSavingContent(editor.getSvgString());
        const state = Store.getState();

        INKIVE.TextOverflowFactory.renderHiddenTextsOverflow();
        const additionalTexts = INKIVE.AdvancedOrderedListFactory.renderHiddenTexts();

        INKIVE.TextOverflowFactory.setChange(false);
        INKIVE.EditorFacade.trigger('page.saved.content', { id: INKIVE.Tool._current_design_id, content: svgContent, skipRenderThumbnail: true });
        INKIVE.PageFactory.savePageState(INKIVE.Tool._current_design_id, svgContent, additionalProps)
          .then(updateSVG, (request) => _callback(false, request.responseText))
          .catch(logError('savePage'));

        const updatedPagesContent = INKIVE.TextOverflowFactory.getUpdatedPagesContentWithHiddenText(state.page, additionalTexts);

        for (const [id, content] of Object.entries(updatedPagesContent)) {
          if (Number(id) === INKIVE.Tool._current_design_id) continue;

          INKIVE.PageFactory.savePageState(id, content);
          INKIVE.EditorFacade.trigger('page.saved.content', { id, content, skipRenderThumbnail: true });
        }
      }

      function updateSVG () {
        INKIVE.C.IS_MOBILE_APP && !quiet && INKIVE.Modal.togglePageLoader(false);

        _callback(true);
      }

      function logSaveError () {
        if (INKIVE.Tool._current_design_id) return;

        logError('_savePage', {
          pageNumber: INKIVE.Tool._current_page_number,
          pages: INKIVE.C.BOOK.num_pages,
          designId: INKIVE.Tool._current_design_id,
          book: INKIVE.C.BOOK.id
        })(new Error('_current_design_id is undefined'));
      }
    },

    /**
     * Function for saving SVG page.
     * pageId    Page number
     * callback   Callback function (isOk)
     */
    save: function (pageId, callback) {
      const that = this;
      callback = callback || $.noop;

      this.onceItsReadyToSave(function () {
        that.saveNotification(true);

        const mode = INKIVE.EditorModeManager.getMode();
        const data = INKIVE.EditorModeManager.getData();

        const isLayout = mode === 'template';
        const isSticker = $.inArray(mode, ['sticker', 'banner', 'placeholder']) > -1;

        const onPageSaved = _.bind(function (status) {
          that.saveNotification();
          callback(status);
        }, that);

        isLayout && that.saveLayout(data, onPageSaved);
        isSticker && that.saveSticker(data, onPageSaved);
      }, _.partial(callback, true));
    },

    clearTab: function (target) {
      $(target).find('.tab-content').empty();
      $(target).find('.breadcrumb').remove();
    },

    addBreadcrumb: function (target, attrs) {
      // Just ignore this for mobile version
      if (INKIVE.C.IS_MOBILE) {
        return;
      }

      $(target + ' .breadcrumb').remove();

      // Add braedcrumb after the search input
      if ($(target + ' .tool-search').length) {
        $(target + ' .tool-search').after(INKIVE.C.HTML.breadcrumbWrapper);
      } else {
        $(target).prepend(INKIVE.C.HTML.breadcrumbWrapper);
      }

      for (let i = 0, l = attrs.length; i < l; i++) {
        const attr = attrs[i];
        const className = l - 1 === i
          ? 'active'
          : '';
        const html = INKIVE.C.HTML.breadcrumbElement(
          attr.href, className,
          INKIVE.TranslateHelper.translate(attr.name)
        );

        $(target + ' .breadcrumb li').append(html);
      }

      const html = $(target + ' .breadcrumb li').html();
      html && $(target + ' .breadcrumb li').html(html.slice(0, -5));
    },

    inkiveLoader: function (display, callback) {
      let logo;
      const ms = 900;

      if (display) {
        const isShowingLogo = !$('#inkiveLoader .inkive-logo').is(':hidden');
        const showLogo = !INKIVE.C.IS_MOBILE && isShowingLogo;
        const delay = isShowingLogo ? 1500 : 0;

        if (showLogo) {
          if (!$('#inkiveLoader').length) {
            $('body').append('<div id="inkiveLoader"><div class="inkive-logo"></div></div>');
          }

          $('#inkiveLoader .inkive-logo').hide();

          logo = new Image();
          logo.onload = _.once(logoLoaded);
          logo.src = 'https://static.inkive.com/assets/img/logos/desygner-wordmark.svg';

          if (INKIVE.C.WHITE_LABEL_CONFIGURATION && INKIVE.C.WHITE_LABEL_CONFIGURATION.logo_url) {
            logo.src = INKIVE.C.WHITE_LABEL_CONFIGURATION.logo_url;
          }
        }

        setTimeout(showLogo ? logo.onload : callback, delay);
      } else {
        INKIVE.C.IS_MOBILE
          ? $('#inkiveLoader').remove()
          : $('#inkiveLoader').fadeOut(ms, function () { $(this).remove(); });

        $('body').removeClass('loading');

        callback && callback();
      }

      function logoLoaded () {
        $('#inkiveLoader .inkive-logo').css('background', 'url(' + logo.src + ') no-repeat center center')
          .css('background-size', 'contain')
          .fadeIn(ms, callback || $.noop);
      }
    },

    traceTab: function () {
      return this.tabButtonTraker;
    },

    show: function () {
      const ms = 900;

      $('#ik-editor').transition({
        opacity: 1
      }, ms, 'ease');

      const action = INKIVE.Helpers.getFragmentTarget();
      if (action && $('.tool-menu [href=' + action + ']').length) {
        $('.tool-menu [href=' + action + ']:first').tab('show');
      } else {
        $('.tool-menu [href]:first').tab('show');
      }
    },

    refreshScroll: function (target) {
      if ($(target).hasClass('antiscroll-wrap')) {
        $(target).data('antiscroll').refresh();
      } else {
        $(target).find('.antiscroll-wrap').data('antiscroll').refresh();
      }
    },

    scrollTop: function (target) {
      const verticalScroll = $(target).find('.antiscroll-wrap').data('antiscroll').vertical;
      if (verticalScroll) {
        verticalScroll.innerEl.scrollTop = 0;
        verticalScroll.update();
      }
    },

    // tool.load page 1615 to 1790
    load: async function (pageNumber, callback, versionId, pageIsEmpty, forceNoCache) {
      await new Promise(resolve => INKIVE.ProjectFacade.getInfo().then(resolve));

      INKIVE.Tool._current_page_number = parseInt(pageNumber);
      const editor = this.editor;
      const design = INKIVE.ProjectFacade.get('design', {
        page_number: pageNumber
      });

      if (!design || !design.design_id) throw new Error('Page not found');

      callback = callback || $.noop;

      clearOldPageSavingInterval();

      if (pageIsEmpty) {
        const svgContent = Base64.decode(INKIVE.C.BLANK_SVG);
        INKIVE.Tool._current_design_id = design.design_id;
        loadSvgString(svgContent, design.design_id);
        return;
      }

      try {
        if (versionId) return loadPageFromServer();
        return loadPageFromService();
      } catch (err) {
        INKIVE.Tool._current_design_id = null;
        INKIVE.Tool._current_page_number = 0;
        console.error(err);

        $.ajax({
          type: 'post',
          dataType: 'json',
          url: `${BASE_URL}untidy-api/log/error`,
          data: {
            name: 'Missing INKIVE.Tool._current_design_id',
            data: {
              file: 'tool.js',
              ref: 'load',
              book: INKIVE.C.BOOK.id,
              err
            }
          }
        });
      }

      function clearOldPageSavingInterval () {
        clearTimeout(INKIVE.Tool._autoSaveTimeout);
        INKIVE.Tool._autoSaveTimeout = null;
      }

      async function loadPageFromServer () {
        editor.loadingElement(true);

        try {
          const version = versionId ? `?version=${versionId}` : '';
          const endpoint = `business/projects/${INKIVE.C.BOOK.id}/pages/${design.design_id}${version}`;
          const project = await INKIVE.DesygnerApi.get(endpoint);

          INKIVE.Tool._current_design_id = parseInt(project.id);
          INKIVE.Tool._current_page_content = project.content;
          INKIVE.Tool._current_design_id || $.ajax({
            type: 'post',
            dataType: 'json',
            url: `${BASE_URL}untidy-api/log/error`,
            data: {
              name: 'Missing INKIVE.Tool._current_design_id',
              data: {
                file: 'tool.js',
                ref: 'loadPageFromServer',
                book: INKIVE.C.BOOK.id
              }
            }
          });

          INKIVE.ProjectFacade.checkDesignId();

          // TODO?
          // const newImagesData = INKIVE.ImagesFactory.setImagesData(
          //   result.images
          // );
          // _.each(newImagesData, function (imageData) {
          //   imageData.stored = true;
          // });

          const svgContent = project.content
            ? project.content
            : Base64.decode(INKIVE.C.BLANK_SVG);

          if (INKIVE.Tool._current_page_number !== project.index) {
            console.warn(
              `Page load aborted. Current page: ${INKIVE.Tool._current_page_number}. Trying to load: ${project.index}`);

            return;
          }

          loadSvgString(svgContent, project.id);
        } catch (err) {
          $('#inkiveLoader').hide();
          INKIVE.Tool._current_page_number = INKIVE.Tool._previous_page_number;
          INKIVE.EditorFacade.trigger('page.load_fail');
        }
      }

      async function loadPageFromService () {
        editor.loadingElement(true);

        try {
          const project = await INKIVE.PageFactory.getPage(Number(design.design_id));

          INKIVE.Tool._current_design_id = parseInt(project.id);
          INKIVE.Tool._current_page_content = project.content;
          INKIVE.Tool._current_design_id || $.ajax({
            type: 'post',
            dataType: 'json',
            url: `${BASE_URL}untidy-api/log/error`,
            data: {
              name: 'Missing INKIVE.Tool._current_design_id',
              data: {
                file: 'tool.js',
                ref: 'loadPageFromService',
                book: INKIVE.C.BOOK.id
              }
            }
          });

          INKIVE.ProjectFacade.checkDesignId();

          // TODO?
          // const newImagesData = INKIVE.ImagesFactory.setImagesData(
          //   result.images
          // );
          // _.each(newImagesData, function (imageData) {
          //   imageData.stored = true;
          // });

          const svgContent = project.content
            ? project.content
            : Base64.decode(INKIVE.C.BLANK_SVG);

          if (INKIVE.Tool._current_page_number !== project.index) {
            console.warn(
              `Page load aborted. Current page: ${INKIVE.Tool._current_page_number}. Trying to load: ${project.index}`);
            editor.loadingElement(false);

            return;
          }

          loadSvgString(svgContent, project.id);
          editor.loadingElement(false);
        } catch (err) {
          logError('loadPageFromService')(err);
          editor.loadingElement(false);
          $('#inkiveLoader').hide();
          INKIVE.Tool._current_page_number = INKIVE.Tool._previous_page_number;
          INKIVE.EditorFacade.trigger('page.load_fail');
        }
      }

      function loadSvgString (svgString, designId) {
        const svgContent = clipPathCleanup(svgString);

        editor.loadSvgString(svgContent, function () {
          const isEmpty = $('#svgroot .main').find(':not(title)').length === 0;
          const layoutId = window.location.search.match(/t=(\d+)/);
          const isAutomaticTemplate =
            isEmpty && layoutId && INKIVE.Tool._current_page_number === 1;
          const svgCont = editor.getSvgString();

          isAutomaticTemplate || INKIVE.EditorFacade.handle('cache', 'set', {
            design_id: designId,
            data: svgCont
          });

          INKIVE.C.IS_MOBILE || $('#canvas-panel').css('top', 52);

          if (isAutomaticTemplate) {
            editor.loadingElement(true);
            INKIVE.DesignFacade.set('template', {
              designed: { id: layoutId[1] }
            });

            INKIVE.DesignFacade.once('template.update.designed', function () {
              editor.loadingElement(false);
              INKIVE.Helpers.displayImagesLoadingAnimation();
            });
          }

          $('#outsideCanvasSelectorGroup, #image-quality-box-group').remove();
          const $element = $('#svgcontent').find('g.main');
          const tool = INKIVE.Tool.getInstance();

          $element.find('.element').each(function (index, elem) {
            const isElementOutsideCanvas =
              !INKIVE.Helpers.isElementInCanvas(elem) &&
              !INKIVE.Helpers.isElementPartiallyInCanvas(elem);
            if (isElementOutsideCanvas) {
              tool.editor.canvas.removeFromSelection([elem]);
              $(elem).remove();
            }
          });

          if (INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.LOGO) {
            INKIVE.DesignFacade.set('background', { color: 'none' });
            INKIVE.EditorModeManager.setMode('logo');
          }

          const isBrandTemplate =
            INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.TEMPLATE;
          isBrandTemplate && INKIVE.EditorModeManager.setMode('brand_template');

          tool.editor.initEditor();
          INKIVE.EditorFacade.handle('zoom', 'fit');

          const sceneTitleElement = document.querySelector('#svgroot .main title');
          if (sceneTitleElement) sceneTitleElement.textContent = INKIVE.TranslateHelper.translate('tool.general.more_options');

          tool.resize();

          INKIVE.History.initialize({
            textMock: document.querySelector('#textmock') && INKIVE.DesignFacade.editor.getSvgString(document.querySelector('#textmock')),
            svg: svgContent,
            hiddenContent: {}
          });

          editor.loadingElement(false);
          callback();
        });
      }
    },

    // Scroll
    initScrollDetect: function (elem, call) {
      if (!$(elem).find('.scrollDetect').length) {
        $(elem).append('<div class="scrollDetect hide"></div>');
      }

      const $scrollDetect = $(elem).find('.scrollDetect');
      const inst = $(elem).data('inst');
      $(elem).find('.scrollDetect').data('inst', inst);

      firstCall();

      function firstCall () {
        let isEnd = false;
        call(function () {
          const $inner = $(elem).closest('.antiscroll-inner');

          let scrollHeight = $inner.get(0).scrollHeight;
          const height = $inner.height();

          if (!scrollHeight) {
            const $dummy = $inner.clone().css('visibility', 'hidden').appendTo($('body'));
            scrollHeight = $dummy.get(0).scrollHeight;
            $dummy.remove();
          }

          if (scrollHeight <= height && !isEnd) {
            firstCall();
          } else {
            scrollEvent();
          }
        }, function () {
          isEnd = true;
          $scrollDetect.remove();
        });
      }

      function scrollEvent () {
        const $inner = $(elem).closest('.antiscroll-inner');
        const debouncedCheck = _.debounce(scrollCheck, 1000);

        // scroll
        $inner.unbind('scroll');
        $inner.on('scroll', scrollCheck);

        function scrollCheck () {
          if ($scrollDetect.data('inst') !== $(elem).data('inst')) return;
          if ($scrollDetect.data('working')) {
            debouncedCheck();
            return;
          }

          const scrollHeight = $inner.get(0).scrollHeight;
          const scrollTop = $inner.get(0).scrollTop;
          const height = $inner.height();

          const per = Math.round((scrollTop + height) / scrollHeight * 100);

          $scrollDetect.data('per', per);

          if (per >= 99) {
            $scrollDetect.data('working', 1);

            call(function () {
              $scrollDetect.data('working', 0);
            }, function () {
              $inner.unbind('scroll');
              $scrollDetect.remove();
            });
          }
        }
      }
    },

    // Thumb
    clearThumb: function (elem) {
      $(elem).find('.thumbnail-wrapper').remove();
    },

    updateThumbImage: function (id, src) {
      clearInterval(INKIVE.Tool._intervalThumb[id]);
      INKIVE.Tool._intervalThumb[id] = null;

      const $img = $('img#' + id);
      const $thumb = $img.parents('.thumbnail');
      const container = $img.parents('.thumbnail-wrapper');
      const data = container.data('masonry');
      const columnWidth = $thumb.width() || (data && data.options.columnWidth);
      let tryCount = 0;

      INKIVE.Tool._intervalThumb[id] = setInterval(function () {
        INKIVE.Helpers.imageLoader(src, function (status, img) {
          if (status === INKIVE.C.Status.success) {
            $img.attr('src', src);
            $thumb.css('width', columnWidth);
            $thumb.css('height', img.height / img.width * columnWidth);
            data && container.masonry();

            clearInterval(INKIVE.Tool._intervalThumb[id]);
            INKIVE.Tool._intervalThumb[id] = null;
          }
        });

        if (tryCount > 20) {
          $img.attr('src', INKIVE.C.THUMB_NOCOVER);

          $thumb.css('width', columnWidth);
          $thumb.css('height', 140);
          data && container.masonry();

          clearInterval(INKIVE.Tool._intervalThumb[id]);
          INKIVE.Tool._intervalThumb[id] = null;
        }

        tryCount++;
      }, 3000);
    },

    removeImportedElement: function (callback, event) {
      INKIVE.Modal.alertMessage(INKIVE.TemplatesHelper('alert_span', {
        text: INKIVE.TranslateHelper.translate('tool.general.delete_imported')
      }), {
        callback: [function () {
          const $target = $(event.target);
          const $thumbnailWrapper = $target.parents('.thumbnail-wrapper');

          callback().then(function () {
            $target.closest('.thumbnail').remove();

            $thumbnailWrapper.masonry(constants.sidebar.thumbnail.masonryConfig);
          }, function () {
            toastr.error('Error');
          });
        }, _.noop
        ]
      });
    },

    getOverlayHtml: function (elem, item, tooltipHtml) {
      let overlayHtml = '';

      if (elem.parents('#element-popupmenu').length) {
        return '';
      }

      tooltipHtml = tooltipHtml || '';
      let isBackgroundAllowed = INKIVE.C.BOOK.book_type !== INKIVE.C.BOOK_TYPE.RESTRICTED_DESIGN;

      if (!isBackgroundAllowed) {
        const bgRestrictions = INKIVE.RestrictionsFacade.getElementRestrictions('background');
        isBackgroundAllowed = bgRestrictions && bgRestrictions.length && bgRestrictions[0].image;
      }
      const imported = elem.parents('.imported-elements').length;
      let type = _.isString(item)
        ? item
        : item.id.split('-')[0];

      if (_.contains(['photo', 'background', 'sticker'], type)) {
        const isImage = type !== 'sticker';
        if (isImage) {
          type = 'image';
        }

        overlayHtml =
          '<div ' + tooltipHtml + '  class="' + (isImage
            ? ''
            : 'hidden') + ' overlay ' + type + '">' +
          '<ul class="options">' +
          '<li data-type="' + type + '" data-placement="bottom" data-popover="tooltip" data-original-title="' +
          INKIVE.TranslateHelper.translate(isImage
            ? 'tool.images.tooltip.image'
            : 'tool.icon.tooltip.add') + '">' +
          '<i class="fa fa-plus"></i>' +
          '</li>' +
          '<li data-type="replace-' + type + '" class="' + (isImage
            ? 'hidden'
            : '') +
          '" data-placement="bottom" data-popover="tooltip" data-original-title="' +
          INKIVE.TranslateHelper.translate(isImage
            ? 'tool.images.tooltip.replace_image'
            : 'tool.icon.tooltip.replace') +
          '">' +
          '<i class="fa fa-refresh"></i>' +
          '</li>' +
          (isImage && isBackgroundAllowed
            ? ('<li data-type="background" data-placement="bottom" data-popover="tooltip" data-original-title="' +
              INKIVE.TranslateHelper.translate('popupmenu.tooltip.set_background') + '">' +
              '<i class="fa fa-th"></i>' +
              '</li>')
            : '') +
          (imported
            ? ('<li data-type="delete" data-placement="bottom" data-popover="tooltip" data-original-title="' +
              INKIVE.TranslateHelper.translate('popupmenu.tooltip.remove') + '">' +
              '<i class="desygner-icon-delete"></i>' +
              '</li>')
            : '') +
          '</ul>' +
          '</div>';
      }

      return overlayHtml;
    },

    addThumbItem: function (elem, items, callback, isPrepend) {
      const that = this;
      const thumbs = [];

      const container = $(elem).hasClass('thumbnail-wrapper')
        ? $(elem)
        : $(elem).find('.thumbnail-wrapper');

      container.masonry();

      const data = container.data('masonry');
      let tooltipHtml = '';
      const debouncedMasonryRefresh = _.debounce(masonryRefresh, 1000);

      if (!$.isArray(items)) items = [items];

      const addedSrc = [];
      _.each(items, function (item) {
        if (item.data && item.data.name && item.data.name.trim().length && item.data.name !== 'search') {
          tooltipHtml = ' data-popover="tooltip" data-original-title="' + item.data.name + '" ';
        }

        let thumbSrc = item.src;
        let originalSrc = item.original;

        if (item.data && item.data.version) {
          if (item.data.version.original) {
            originalSrc = item.data.version.original;
          }
          if (item.data.version.thumb) {
            thumbSrc = item.data.version.thumb;

            const thumbWidth = item.data.version.thumb_width;
            const originalWidth = item.data.version.original_width;

            if (!INKIVE.C.IS_MOBILE && thumbWidth && originalWidth && thumbWidth >= originalWidth) {
              thumbSrc = item.data.version.original;
            }
          }
        }

        thumbSrc = INKIVE.Helpers.getCORSSecureUrl(thumbSrc);

        if (isThumbAlreadyAdded(thumbSrc)) {
          return true;
        }

        addedSrc.push(thumbSrc);

        const innerElement = item.svg || '<img id="' + item.id + '" src="' + thumbSrc +
          (originalSrc
            ? '" data-original-src="' + originalSrc
            : '') +
          (item.project_id
            ? '" data-project-id="' + item.project_id
            : '') +
          (item.db_url
            ? '" data-db-url="' + item.db_url
            : '') +
          '">';

        const imageOverlayHtml = that.getOverlayHtml(elem, item, tooltipHtml);
        const thumb = $.parseHTML(
          '<div class="thumbnail' + (item.cls || '') + '">' +
          '<a class="item" ' + tooltipHtml + '>' + innerElement + '</a>' + imageOverlayHtml +
          '</div>'
        );

        item.width && $(thumb).css('width', item.width);
        item.height && $(thumb).css('height', item.height);

        if (item.sticker_value !== undefined) {
          const value = item.sticker_value > 0
            ? item.sticker_value
            : '';
          $(thumb).append($.parseHTML(
            '<div class="thumb_sticker" data-popover="tooltip" data-original-title="' + item.sticker_tooltip + '">' + value + '</div>'));
        }

        // Change data
        if (item.data && typeof (item.data) === 'object') {
          const d = item.data;
          for (const n in d) {
            $(thumb).find('.item').data(n, d[n]);
          }
        }

        if (item.width && item.height) {
          recalculate($(thumb), item, item.width, item.height);
        } else if (item.width) {
          $(thumb).css('width', item.width);
        } else if (item.height) $(thumb).css('height', item.height);

        $(thumb).find('img').each(function () {
          const imgSrc = $(this).attr('src');
          const $img = $(this);
          const $thumb = $(this).parents('.thumbnail');
          const width = parseInt($thumb.css('width'));
          const height = parseInt($thumb.css('height'));

          $img.removeAttr('src');
          $img.hide();

          INKIVE.Helpers.imageLoader(imgSrc, function (status, img) {
            processImageLabel($(thumb), item);

            if (status === INKIVE.C.Status.success) {
              let needRecalculatePosition = (!width || !height ||
                width !== img.width ||
                height !== img.height
              );

              if (item.data && item.data.loadType === INKIVE.C.SHUTTERSTOCK) {
                needRecalculatePosition = false;
              }

              $img.attr('src', imgSrc).css('display', 'block');
              $img.siblings('.subscription-label').css('opacity', 1);

              if (needRecalculatePosition) {
                recalculate($thumb, item, img.width, img.height);
                debouncedMasonryRefresh();
              }
            } else {
              if (item.isNocover) {
                $img.attr('src', INKIVE.C.THUMB_NOCOVER).fadeIn('slow')
                  .parent().css('background', '#EEEEEE');

                if (!width || !height) {
                  $thumb.css('width', 130);
                  $thumb.css('height', 86);
                  debouncedMasonryRefresh();
                }
              } else {
                container.masonry('remove', $thumb);
                debouncedMasonryRefresh();
              }
            }

            item.data &&
            item.data.svg_url &&
            $img.data('svg-url', item.data.svg_url);
            item?.provider && $img.data('provider', item.provider);
          });
        });

        thumbs.push(thumb[0]);
      });

      if (thumbs.length) {
        const functionName = isPrepend
          ? 'prependThumb'
          : 'appendThumb';
        container[functionName](thumbs, false, function (thumb) {
          if (callback) callback(thumb, elem);
        });
      }

      function masonryRefresh () {
        container.masonry();
      }

      function recalculate ($thumb, item, width, height) {
        const columnMargin = 10;
        const triggerProportion = Infinity; // 2.5;

        const formatProportion = width / height;
        const thumbWidth = formatProportion > triggerProportion
          ? data.options.columnWidth * 2 + columnMargin
          : data.options.columnWidth;
        const thumbHeight = height / width * thumbWidth;

        $thumb.css('width', thumbWidth);
        $thumb.css('height', thumbHeight);

        item.data && item.data.loadType === INKIVE.C.SHUTTERSTOCK &&
          $thumb.find('img').css('width', thumbWidth).css('height', thumbHeight);
      }

      function isThumbAlreadyAdded (thumbSrc) {
        let thumbAdded = false;
        container.find('img').each(function () {
          if (this.src === thumbSrc) {
            thumbAdded = true;
            return false;
          }
        });
        _.each(addedSrc, function (src) {
          if (src === thumbSrc) {
            thumbAdded = true;
          }
        });
        return thumbAdded;
      }

      function processImageLabel ($thumb, item) {
        if (!item || !item.data || !item.data.search) return;

        let label = '';
        let hoverText = '';
        const isSubscriptionImage = item.data.subscription_image;
        const isSubscribedUser = item.data.subscribed_user;
        const t = INKIVE.TranslateHelper.translate;
        let additionalClass = '';

        if (isSubscriptionImage) {
          additionalClass = isSubscribedUser ? '' : 'free-user';
          hoverText = t('tool.search.' + (isSubscribedUser ? 'add_to_canvas' : 'upgrade'));
          label = ({
            pro: 'Pro+',
            business: 'Business',
            enterprise: 'Enterprise Resource',
            ultimate: 'Ultimate',
            content2: 'Unlimited Shutterstock'
          })[item.data.originalData.model];
        } else if (item.data.price || item.data.originalData.model === 'oneoff') {
          const currency = 'usd'; // TODO
          hoverText = INKIVE.Helpers.getPriceString(item.data.price[currency], currency);
          label = t('tool.search.buy');
        } else {
          hoverText = t('tool.search.add_to_canvas');
        }

        $thumb.data('original_height', item.data.version.original_height);
        $thumb.data('original_width', item.data.version.original_width);
        $thumb.data('subscribed_user', item.data.subscribed_user);
        $thumb.data('subscription_image', item.data.subscription_image);
        $thumb.data('label', label);
        $thumb.data('hover-text', hoverText);

        if (label || hoverText) {
          const tagHtml = (includeParentNode = false, hover = false) => {
            const parentNode = `<div class="subscription-label ${additionalClass}" style="background: ${INKIVE.C.WHITE_LABEL_CONFIGURATION.colors.highlight}">`;
            const endParentNode = '</div>';
            const content = isSubscriptionImage && !isSubscribedUser
              ? `<icon><svg><use xlink:href="#crown---gold"></use></svg></icon>${label}`
              : '';

            if (includeParentNode) {
              return `${parentNode}${content}${endParentNode}`;
            } else {
              return hover ? hoverText : content;
            }
          };
          $thumb.append(tagHtml(true));

          $thumb.find('.overlay').addClass('align-bottom');
          $thumb.hover(
            function () {
              $(this).find('.subscription-label').addClass('hover').html(tagHtml(false, true));
            }, function () {
              $(this).find('.subscription-label').removeClass('hover').html(tagHtml(false, false));
            }
          );
        }
      }
    },

    deleteThumb: function (elem, thumb) {
      let container;
      if ($(elem).hasClass('thumbnail-wrapper')) {
        container = $(elem);
      } else {
        container = $(elem).find('.thumbnail-wrapper');
      }

      container.removeThumb(thumb);
    },

    // Tab worker
    initTab: function (target, callback, opts) {
      const name = target.replace('#', '');
      const cleanName = name.replace(/^(accordion|tab)/, '').toLowerCase();

      if (window.INKIVE.Tabs[cleanName]) {
        window.INKIVE.Tabs[cleanName].show();
      } else if (typeof (this[name]) !== 'undefined') {
        this[name](target, opts, callback);
      }

      window.INKIVE.Tabs[cleanName] || this.initScroll(target);
      /*
      $(target).reloadThumb();
      $(target).data('init', true);
      */
    },

    tabSearch: function (target) {
      if (!$(target).data('init')) {
        INKIVE.Tool.preloadLayoutFormat();

        // Init tabs
        $(target).find('.tabs').tabs({
          activate: function () { $('.tool-search form').trigger('submit'); }
        });

        $(target).find('.iradio_square-yellow.checked').addClass('desygner-icon-check');

        $(target).find('input[type=radio]').on('ifClicked', function (event) {
          const $parents = $(event.target).parents('.ui-tabs-panel');
          $parents.find('.iradio_square-yellow').removeClass('desygner-icon-check');

          _.defer(function () {
            $parents.find('.iradio_square-yellow.checked').addClass('desygner-icon-check');
            $('.tool-search form').trigger('submit');
          });
        });
      }
    },

    /** ** Callbacks ***************************************************************************************************/

    smartImageLoad: function ($elem, position, additionalAttributes) {
      const $img = $elem.is('img')
        ? $elem
        : $elem.find('img');
      const imageUrl = $img.attr('src');

      const data = INKIVE.ImagesFactory.getImageOriginalData(imageUrl);
      const isSearchResult = data && (data.search || $.inArray(
        data.source, ['dropbox', 'google', 'facebook', 'assetbank']
      ) > -1);

      const size = additionalAttributes.size || this.getImageSizeBasedOnSVGSize($img);

      const $svgContent = $('#svgcontent');
      const SVGWidth = parseInt($svgContent.attr('width'));
      const SVGHeight = parseInt($svgContent.attr('height'));
      const isExternalFromKW = additionalAttributes.external;

      INKIVE.DesignFacade.create('image', _.extend({
        size,
        position: position || {
          x: Math.round((SVGWidth - size.width) / 2),
          y: Math.round((SVGHeight - size.height) / 2)
        },
        source: isExternalFromKW
          ? {
              url: additionalAttributes.originalImageVersion || imageUrl,
              external_resize: true
            }
          : {
              url: imageUrl,
              external_resize: (isSearchResult && !INKIVE.ImagesFactory.isAmazonImage(imageUrl))
            }
      }, additionalAttributes));
    },

    getImageSizeBasedOnSVGSize: function ($img) {
      const $thumbnail = $img.closest('.thumbnail');

      let imageWidth = $img.width() || $thumbnail.width() || ($img[0] && $img[0].width);
      let imageHeight = $img.height() || $thumbnail.height() || ($img[0] && $img[0].height);

      if ($thumbnail.data('external_source') === INKIVE.C.SHUTTERSTOCK) {
        imageWidth = $thumbnail.data('original_width');
        imageHeight = $thumbnail.data('original_height');
      }

      return this.getDimensionsSizeBasedOnSVGSize(imageWidth, imageHeight);
    },

    getDimensionsSizeBasedOnSVGSize: function (imageWidth, imageHeight) {
      const $svgContent = $('#svgcontent');
      const SVGWidth = parseInt($svgContent.attr('width'));
      const SVGHeight = parseInt($svgContent.attr('height'));

      const SVGRatio = SVGWidth / SVGHeight;
      const imageRatio = imageWidth / imageHeight;

      const width = imageRatio > SVGRatio
        ? SVGWidth * 0.8
        : (SVGHeight * 0.8) * imageRatio;

      const height = imageRatio > SVGRatio
        ? width / imageRatio
        : SVGHeight * 0.8;

      return {
        width,
        height
      };
    },

    callbackImages: function (thumb) {
      const that = this;
      const editor = this.editor;
      that.editor.canvas.showOverlayElements();

      $(thumb).initDragable({
        callback: {
          click: function (elem, evt) {
            const targetAction = evt.target.closest('li');
            const eventType = targetAction && targetAction.dataset.type;
            const canvasMode = editor.canvas.getMode();
            let $img = $(elem).find('img');
            const data = $(elem).find('.item').data();
            const abId = data.loadType === 'ab' && data.originalData
              ? data.originalData.object_id
              : null;

            if (!$img.length) $img = $(elem);

            editor.canvas._t.layout_prvElem = null;
            editor.canvas._t.layout_prvAttr = null;

            if (!$img.attr('src') || (!$img.width() && !$img.height())) {
              that.editor.canvas.call('advice.show', 'thumb-not-load');
              return;
            }

            if (data.loadType === INKIVE.C.SHUTTERSTOCK) {
              $img.parents('.thumbnail').data('in_shopping_cart') || this.mouseup(elem, evt);
              return;
            }

            if (eventType === 'background' || canvasMode === 'replace-background') {
              editor.canvas.clearSelection();
              INKIVE.DesignFacade.set('background', {
                source: $img.attr('src'),
                ab_id: abId,
                originalSrc: $img.data('originalSrc')
              });
              this.processBackendImageTask($img, data);
              return;
            }

            if (eventType === 'delete') {
              const callback = function () {
                const deferred = $.Deferred();
                const $thumbnail = $(evt.target).parents('.thumbnail');
                const $img = $thumbnail.find('img');
                let originalUrl = $img.data('original-src') || $thumbnail.data('original-src');
                const projectId = $img.data('project-id') || $thumbnail.data('project-id');

                if (!originalUrl) {
                  originalUrl = $img.parent().data().version && $img.parent().data().version.original;
                }

                INKIVE.Helpers.api('photo/remove', 'POST', {
                  id: projectId || INKIVE.C.BOOK.id,
                  key: $img.data('db-url') || originalUrl,
                  type: 'photo'
                }, function (result, status) {
                  status && deferred.resolve(result);
                  status || deferred.reject(result);
                });

                return deferred.promise();
              };

              that.removeImportedElement(callback, evt);
              return;
            }

            if (eventType === 'replace-image' || canvasMode === 'replace-image') {
              const elems = editor.canvas.getSelectedElems();
              const isStickerSubelement = $(elems).is('.sticker') && $(elems).find('image.subelement').length;
              const isImageElement = $(elems[0]).is('image.element') || isStickerSubelement;
              const hasReplace = elems.length === 1 && isImageElement;

              if (hasReplace) {
                this.overLayoutImage(elem);
                this.mouseup(elem);
                INKIVE.ImagesFactory.removeImageFilter(elems[0]);
              } else {
                that.editor.canvas.call('advice.show', 'image-replacement-selection');
              }
              return;
            }

            if (!INKIVE.RestrictionsFacade.isFunctionalityAllowed('image_add')) {
              return;
            }

            const size = that.getImageSizeBasedOnSVGSize($img);
            const $svgContent = $('#svgcontent');
            const SVGWidth = parseInt($svgContent.attr('width'));
            const SVGHeight = parseInt($svgContent.attr('height'));
            const isExternal = data.external;

            INKIVE.DesignFacade.create('image', {
              source: {
                url: isExternal ? data?.version?.original || $img.attr('src') : $img.attr('src'),
                external_resize: isExternal
              },
              position: {
                x: Math.round((SVGWidth - size.width) / 2),
                y: Math.round((SVGHeight - size.height) / 2)
              },
              size: {
                width: size.width,
                height: size.height
              },
              imported: $(evt.target).parents('.imported-elements').length > 0,
              ab_id: abId
            });

            this.processBackendImageTask($img, data);
          },

          overLayoutImage: function (elem, opts) {
            const $item = $(elem).find('.item');
            const image = elem.tagName === 'image' ? elem : $(elem).find('img').get(0);

            if (typeof image === 'undefined') {
              logInfo('overLayoutImage', {
                rootElement: elem.tagName,
                elementClasses: [...elem.classList],
                message: 'Can\'t locate image element'
              });
              return;
            }

            const layoutBox = editor.canvas.runExtensions('overLayoutImage', {
              ...opts,
              elem: image,
              type: 'image',
              skipHistory: true
            });

            layoutBox && $item.data('layoutTarget', layoutBox);
          },

          mousemove: function (elem, evt) {
            const offset = editor.getOffset();
            const mouseX = evt.clientX;
            const mouseY = evt.clientY;
            const opts = {
              imageRatio: 1.2,
              mouse_x: mouseX - offset.x,
              mouse_y: mouseY - offset.y,
              skipHistory: true
            };

            this.overLayoutImage(elem, opts);
          },

          mouseup: function (elem, evt) {
            const clickedButton = evt && evt.target.closest('li');
            const isBackground = clickedButton && clickedButton.dataset.type === 'background';
            const isReplace = clickedButton && clickedButton.dataset.type === 'replace-image';
            const designFacade = INKIVE.DesignFacade;
            const editorFacade = INKIVE.EditorFacade;
            const $item = $(elem).find('.item');
            const $img = $(elem).find('img');
            const data = $item.data();
            const hasTarget = $(data.layoutTarget).is('[id]');
            const hasOriginalImageVersion = data.version?.original;
            const isShutterstock = $(elem).data('external_source') === INKIVE.C.SHUTTERSTOCK;
            const abId = data.loadType === 'ab' && data.originalData
              ? data.originalData.object_id
              : null;
            let isPlaceHolder = false;

            if (editor.canvas.getMode().match('replace-') && !hasTarget) { return; }

            if (typeof data.version === 'undefined' && hasTarget === false) {
              const size = that.getImageSizeBasedOnSVGSize($img);
              const $svgContent = $('#svgcontent');
              const SVGWidth = parseInt($svgContent.attr('width'));
              const SVGHeight = parseInt($svgContent.attr('height'));
              const isExternal = data.external;

              designFacade.create('image', {
                source: {
                  url: isExternal ? data?.version?.original || $img.attr('src') : $img.attr('src'),
                  external_resize: isExternal
                },
                position: {
                  x: Math.round((SVGWidth - size.width) / 2),
                  y: Math.round((SVGHeight - size.height) / 2)
                },
                size: {
                  width: size.width,
                  height: size.height
                },
                imported: $(evt.target).parents('.imported-elements').length > 0,
                ab_id: abId
              });
            }

            if (isShutterstock && isReplace) {
              this.overLayoutImage(elem, {
                imageRatio: 1.2,
                skipHistory: true
              });
            }

            if (editor.canvas._t.layout_prvElem) {
              if (!hasOriginalImageVersion && hasTarget) {
                designFacade.trigger('image.replace', { id: editor.canvas._t.layout_prvElem.id });
              }

              isPlaceHolder = /imageplaceholder_new\.svg$/.test(editor.canvas._t.layout_prvAttr.url);
              editor.canvas._t.layout_prvElem = null;
              editor.canvas._t.layout_prvAttr = null;
            }

            if (hasOriginalImageVersion) {
              const additionalAttributes = {
                ab_id: abId,
                imported: $('#tool-panel').find('#' + $img.attr('id')).parents('.imported-elements').length > 0,
                originalImageVersion: hasOriginalImageVersion,
                external: data.external
              };
              additionalAttributes.img_frame = isPlaceHolder;

              const canAdd = INKIVE.RestrictionsFacade.isFunctionalityAllowed('image_add');
              const hasProcessedShutterstockImage = (() => {
                if (!isShutterstock) return false;

                data.originalData.provider_data.send_to_user_bucket = true;
                data.originalData.provider_data.platform = 'thumb';

                return this.processShutterstockImage(data, additionalAttributes, $item, isBackground);
              })();

              const isTargetVideo = data.layoutTarget && INKIVE.DesignFacade.getType(data.layoutTarget) === 'video';
              if (data.layoutTarget && !isTargetVideo) {
                const $layoutTarget = $(data.layoutTarget);
                const targetId = $layoutTarget.parents('g.background').length
                  ? 'background'
                  : data.layoutTarget.getAttribute('id');

                if (!canAdd && !INKIVE.RestrictionsFacade.isReplaceAllowed(targetId)) {
                  return;
                }

                if (!isShutterstock) {
                  $layoutTarget.data('external_source', null);
                  $layoutTarget.data('external_id', null);
                }

                const url = (() => {
                  const $itemData = $item.data();
                  const licencedUrl = $itemData.version && $itemData.version.original;
                  if (licencedUrl) return INKIVE.Helpers.getCORSSecureUrl(licencedUrl);

                  return data.version.tab || data.version.original;
                })();

                INKIVE.DesignFacade.set(targetId, _.extend({
                  skipHistory: true,
                  source: {
                    url,
                    preload: true
                  },
                  keep_box_size: true
                }, additionalAttributes));
              } else if (canAdd) {
                const bb = $item.get(0).getBoundingClientRect();
                const zoom = editorFacade.handle('zoom', 'get');
                const offset = editor.getOffset();

                let position = {
                  x: Math.floor4((bb.left - offset.x) / zoom),
                  y: Math.floor4((bb.top - offset.y) / zoom)
                };

                if (!$img.width() && !$img.height()) {
                  that.editor.canvas.call('advice.show', 'thumb-not-load');
                  return;
                }

                if (hasProcessedShutterstockImage) {
                  if (data.layoutTarget) {
                    const targetBb = data.layoutTarget.getBBox();

                    position = {
                      x: targetBb.x,
                      y: targetBb.y
                    };
                    additionalAttributes.size = {
                      width: targetBb.width,
                      height: targetBb.height
                    };
                    data.layoutTarget.remove();
                  } else {
                    position = null;
                  }
                } else if (isShutterstock) {
                  return;
                }

                if (isShutterstock && isBackground) {
                  INKIVE.DesignFacade.set('background', Object.assign({
                    source: $img.attr('src')
                  }, additionalAttributes));
                  return;
                }
                that.smartImageLoad($item, position, additionalAttributes);
              }

              this.processBackendImageTask($img, data);
            }
          },

          processShutterstockImage: function (data, additionalAttributes, $item, isBackground) {
            const isSubscriptionImage = data.subscription_image;

            if (isSubscriptionImage) {
              if (data.subscribed_user) {
                if (_.find(that.getShutterstockImagePresent(), { externalId: data.originalData.id })) {
                  return false;
                }

                additionalAttributes.subscription_image = {
                  items: [{
                    provider: data.originalData.provider,
                    one_off: data.originalData.marketplace.one_off,
                    provider_data: data.originalData.provider_data
                  }],
                  resize_later: true
                };
              } else {
                INKIVE.Helpers.displaySubscriptionModal(null, data.originalData.model);
                return false;
              }
            }

            additionalAttributes.external_source = INKIVE.C.SHUTTERSTOCK;
            additionalAttributes.external_id = data.originalData.id;
            additionalAttributes.keep_box_size = true;
            additionalAttributes.$elem = $item;

            const currency = 'usd'; // TODO;

            isSubscriptionImage || INKIVE.EditorFacade.handle('shopping_cart', 'add', {
              price: data.price[currency],
              licence: 'shutterstock',
              id: data.originalData.id,
              background: isBackground,
              cart_description: data.name || 'marketplace:shopping_cart.shutterstock.cart_description',
              cart_total: 'marketplace:shopping_cart.shutterstock.cart_total',
              data: {
                provider: data.originalData.provider,
                one_off: data.originalData.marketplace.one_off,
                provider_data: data.originalData.provider_data
              },
              preview: data.version.thumb
            });

            return true;
          },

          processBackendImageTask: function ($img, data) {
            const url = data.original_url
              ? 'api/photo/convertedphotos'
              : 'api/search/preferred_photo';
            const parameters = data.original_url
              ? {
                  project_id: INKIVE.C.BOOK.id,
                  url: data.original_url,
                  width: data.original_width,
                  height: data.original_height
                }
              : {
                  photo_id: $img.attr('id').split('_').pop(),
                  src: $img.attr('src')
                };

            $.ajax({
              url: INKIVE.C.BASE_URL + url,
              type: 'POST',
              error: function (e) {
                console.error('Error processing' + url, e);
              },
              data: parameters
            });
          }
        }
      });

      INKIVE.EditorFacade.trigger('imageTab.stock.images.loaded');
    },

    callbackBackgrounds: function (target) {
      const editor = this.editor;

      $(target).initDragable({
        callback: {
          click: _setBackground,
          mouseup: _setBackground,
          mousemove: isFullyLoad
        }
      });

      function _setBackground (elem) {
        isFullyLoad(elem) && setBackground($(elem).find('.item').get(0));
      }

      function isFullyLoad (elem) {
        const $img = $(elem).find('img');
        const isFullyLoad = $img.width() || $img.height();

        isFullyLoad || editor.canvas.call('advice.show', 'thumb-not-load');
        return isFullyLoad;
      }

      function setBackground (elem) {
        const id = $(elem).find('img').attr('id').split('-').pop();
        const url = $(elem).find('img').attr('src');

        INKIVE.DesignFacade.set('background', {
          source: url,
          background_id: id
        });
      }
    },

    getId: function ($elem) {
      return $elem.attr('id')
        ? $elem.attr('id').split('-').pop()
        : 0;
    },

    callbackAdminBackgrounds: function (image, element) {
      const that = this;

      $(image).on('click', function (event) {
        const $image = $(event.target);
        const $thumb = $image.closest('.thumbnail');
        const id = that.getId($image);

        const modalData = new INKIVE.ModalAdminBackground({ id });
        const modal = INKIVE.Modal.modalWindow(modalData.getFormHtml(), {
          width: 600,
          headerIcon: 'icon-backgrounds',
          headerTitle: 'modal.title.edit_background',
          buttons: [{
            title: 'Save',
            onClick: function () {
              const $button = $(this);
              $button.addClass('disabled');

              modalData.saveForm(function (status, data) {
                if (status && data.id) {
                  modal.close();
                  $thumb.toggleClass('grayscale', data.active);
                } else {
                  $button.removeClass('disabled');
                }
              });
            }
          }, {
            title: 'Delete',
            width: '100px',
            cls: 'btn-red',
            onClick: function () {
              const message = INKIVE.TemplatesHelper('alert_span', {
                message: 'modal.alert.delete_background'
              });

              INKIVE.Modal.alertMessage(message, {
                callback: [function () {
                  modalData.deleteForm(function (status) {
                    if (status) {
                      that.deleteThumb(element, $thumb);
                      modal.close();
                    }
                  });
                }, $.noop]
              });
            }
          }]
        });
      });
    },

    callbackAdminStickers: function (image, element) {
      const that = this;

      $(image).on('click', function (event) {
        const $thumb = $(event.target).closest('.thumbnail');
        const $image = $thumb.find('img');
        const id = that.getId($image);

        const modalData = new INKIVE.ModalAdminSticker({
          id,
          isPlaceholder: /^placeholder-/.test($image.attr('id')),
          isText: /^banner-/.test($image.attr('id'))
        });

        const modal = INKIVE.Modal.modalWindow(modalData.getFormHtml(), {
          width: 600,
          headerIcon: 'icon-hipster',
          headerTitle: 'Edit sticker',
          buttons: [{
            title: 'Edit sticker',
            width: '150px',
            onClick: function () {
              const $button = $(this);
              $button.addClass('disabled');

              modalData.saveForm(function (status, data) {
                if (status && data.id) {
                  modal.close();
                  const mode = modalData.opts.isText
                    ? 'banner'
                    : modalData.opts.isPlaceholder
                      ? 'placeholder'
                      : 'sticker';

                  INKIVE.EditorModeManager.setMode(mode, data);
                } else {
                  $button.removeClass('disabled');
                }
              });
            }
          }, {
            title: 'Save & Duplicate',
            width: '150px',
            onClick: function () {
              const $button = $(this);
              $button.addClass('disabled');

              modalData.saveForm(function (status, data) {
                if (status && data.id) {
                  const sticker = data;
                  sticker.id = null;
                  sticker.name = '';
                  $('#tabAdmin dt.active .btn-new-item')
                    .trigger('click', [sticker]);

                  modal.close();
                } else {
                  $button.removeClass('disabled');
                }
              });
            }
          }, {
            title: 'Save',
            width: '150px',
            onClick: function () {
              const $button = $(this);
              $button.addClass('disabled');

              modalData.saveForm(function (status, data) {
                if (status && data.id) {
                  modal.close();

                  if (!data.active) {
                    $thumb.addClass('grayscale');
                  } else {
                    $thumb.removeClass('grayscale');
                  }
                } else {
                  $button.removeClass('disabled');
                }
              });
            }
          }, {
            title: 'Delete',
            width: '100px',
            cls: 'btn-red',
            onClick: function () {
              const message = INKIVE.TemplatesHelper('alert_span', {
                message: 'modal.alert.delete_sticker'
              });

              INKIVE.Modal.alertMessage(message, {
                callback: [function () {
                  modalData.deleteForm(function (status) {
                    if (status) {
                      that.deleteThumb(element, $thumb);
                      modal.close();
                    }
                  });
                }, $.noop]
              });
            }
          }]
        });
      });
    },

    callbackAdminLayouts: function (image, element) {
      const that = this;

      $(image).on('click', function (event) {
        const $image = $(event.target);
        const $thumb = $image.closest('.thumbnail');
        const id = that.getId($image);

        const modalData = new INKIVE.ModalAdminLayout({ id });
        const modal = INKIVE.Modal.modalWindow(modalData.getFormHtml(), {
          width: 500,
          headerIcon: 'icon-news',
          headerTitle: 'modal.title.edit_template',
          buttons: [{
            title: INKIVE.TranslateHelper.translate('modal.title.edit_template'),
            width: '200px',
            onClick: function () {
              const $button = $(this);
              $button.addClass('disabled');

              modalData.saveForm(function (status, data) {
                if (status && data.id) {
                  modal.close();
                  INKIVE.EditorModeManager.setMode('template', data);
                } else {
                  $button.removeClass('disabled');
                }
              });
            }
          }, {
            title: 'Save & duplicate',
            width: '200px',
            onClick: function () {
              const $button = $(this);
              $button.addClass('disabled');

              modalData.saveForm(function (status, data) {
                if (status && data.id) {
                  const layout = data;
                  layout.id = null;
                  layout.name = '';
                  $('#tabAdmin dt.active .btn-new-item')
                    .trigger('click', [layout]);

                  modal.close();
                } else {
                  $button.removeClass('disabled');
                }
              });
            }
          }, {
            title: 'Save',
            width: '200px',
            onClick: function () {
              const $button = $(this);
              $button.addClass('disabled');

              modalData.saveForm(function (status, data) {
                if (status && data.id) {
                  modal.close();
                  $thumb.toggleClass('grayscale', !data.active);
                } else {
                  $button.removeClass('disabled');
                }
              });
            }
          }, {
            title: 'Delete',
            width: '100px',
            cls: 'btn-red',
            onClick: function () {
              const message = INKIVE.TemplatesHelper('alert_span', {
                message: 'modal.alert.delete_template'
              });

              INKIVE.Modal.alertMessage(message, {
                callback: [function () {
                  modalData.deleteForm(function (status) {
                    if (status) {
                      that.deleteThumb(element, $thumb);
                      modal.close();
                    }
                  });
                }, function () {
                }]
              });
            }
          }]
        });
      });
    },

    callbackLayouts: function (thumb) {
      let oldImages = [];
      let layoutId,
        keepImages,
        modal;
      const that = this;
      const editor = that.editor;
      const svgCanvas = editor.canvas;

      const throttleAddLayout = _.throttle(addLayout, 1000, { trailing: false });
      $(thumb).initDragable({
        callback: {
          mousemove: $.noop,
          mouseup: function (thumb) {
            throttleAddLayout($(thumb).find('.item')[0]);
          },
          click: function (thumb) {
            throttleAddLayout($(thumb).find('.item')[0]);
          }
        }
      });

      function addLayout (item) {
        layoutId = $(item).find('img').attr('id').split('-').pop();
        editor.loadingElement(1);
        INKIVE.Helpers.api('search/layout', 'GET', { id: layoutId }, function () {
          const isEmpty = $('#svgroot').find('.main').find(':not(title)').length === 0;
          editor.loadingElement(0);

          /* if (requireNewPage)
            addOnNewPage();
          else */
          if (isEmpty) {
            setTemplate();
          } else {
            displayModalOptions();
          }
        });
      }

      function setTemplate () {
        oldImages = _.map($('#svgcontent ').find('.main image'), function (image) {
          return image.getAttribute('xlink:href');
        });

        editor.loadingElement(1);

        INKIVE.DesignFacade.once('template.update', onTemplateSet);

        _.delay(function () {
          INKIVE.DesignFacade.set('template', {
            keep_stage_size: false,
            designed: { id: layoutId }
          });
        }, 500);
      }

      function onTemplateSet () {
        const $layoutBoxes = $('#svgcontent').find('.main .layoutBox');
        keepImages && _.any($layoutBoxes, function (elem, index) {
          if (oldImages.length > index) {
            svgCanvas.runExtensions('addLayoutImage', {
              elem,
              data: oldImages[index]
            });
          } else {
            return true;
          }
        });

        INKIVE.C.IS_MOBILE
          ? svgCanvas.call('advice.show', 'template-back')
          : $layoutBoxes.length && INKIVE.C.MODE.IS_DESYGNER && svgCanvas.call('advice.show', 'template-placeholders');
        INKIVE.Helpers.displayImagesLoadingAnimation();

        editor.loadingElement(0);
      }

      function displayModalOptions () {
        const newSize = 0;
        modal = INKIVE.Modal.modalWindow(
          INKIVE.TemplatesHelper('modal_layout_load', {
            new_size: newSize,
            current_size: Math.round(svgCanvas.contentW) + 'x' + Math.round(svgCanvas.contentH),
            keep_images: !INKIVE.C.MODE.IS_DESYGNER,
            has_images: $('#svgcontent').find('.main image').length > 0,
            keep_size: !INKIVE.C.MODE.IS_DESYGNER,
            is_same_size: true
          }),
          {
            width: 600,
            headerIcon: 'icon-cloud-download',
            headerTitle: 'modal.title.change_name',
            buttons: [
              {
                title: INKIVE.TranslateHelper.translate('modal.buttons.apply_name'),
                onClick: acceptModal
              }, {
                title: 'Cancel',
                onClick: closeModal
              }
            ]
          }
        );
      }

      function acceptModal () {
        keepImages = $('input[name="keep-images-input"]').is(':checked');
        setTemplate();
        modal.close();
      }

      function closeModal () {
        modal.close();
      }
    },

    callbackStickers: function (target) {
      const that = this;
      const editor = that.editor;
      const canvas = editor.canvas;

      const onClick = _.partial(onEvent, function (bb) {
        const scale = Math.min(canvas.contentW, canvas.contentH) / Math.max(bb.width, bb.height);

        return {
          position: {
            x: (canvas.contentW - bb.width * (scale / 2)) / 2,
            y: (canvas.contentH - bb.height * (scale / 2)) / 2
          },
          size: {
            width: bb.width * (scale / 2),
            height: bb.height * (scale / 2)
          },
          selected: true
        };
      }, 'onclick');

      const onMouseUp = _.partial(onEvent, function (bb) {
        const zoom = INKIVE.EditorFacade.handle('zoom', 'get');
        const offset = editor.getOffset();

        return {
          position: {
            x: Math.floor4((bb.left - offset.x) / zoom),
            y: Math.floor4((bb.top - offset.y) / zoom)
          },
          size: {
            width: Math.floor4(bb.width / zoom),
            height: Math.floor4(bb.height / zoom)
          }
        };
      }, 'onmouseup');

      const isPopupMenuButton = _.any(target, function (element) {
        return $(element).parents('.root-popupmenu').length;
      });

      isPopupMenuButton && _.each(target, function (element) {
        $(element).on('click', _.bind(onClick, element));
      });

      isPopupMenuButton || $(target).initDragable({
        callback: {
          mousemove: $.noop,
          click: onClick,
          mouseup: onMouseUp
        }
      });

      function onEvent (getData, eventName, thumb, event) {
        thumb = $(this).is('.thumbnail')
          ? this
          : thumb;

        const isDraggedImage = eventName === 'onmouseup';
        let $image = $(thumb).find('.item img');

        // Dragged images need mouse position to place the sticker.
        $image = isDraggedImage
          ? $image
          : $('#' + $image.attr('id'));
        const bb = $image.get(0).getBoundingClientRect();

        let bboxData = getData(bb);
        let replacementId = null;

        if (event && $(event.target).closest('li').attr('data-type') === 'replace-sticker') {
          const selectedElements = editor.canvas.getSelectedElems();
          const $selectedElement = $(selectedElements[0]);
          const id = $selectedElement.attr('id');

          const bbox = $selectedElement[0].getBBox();
          const size = Math.max(bbox.width, bbox.height);

          bboxData = {
            size: {
              width: size,
              height: size
            },
            position: {
              x: bbox.x,
              y: bbox.y
            },
            selected: true
          };
          INKIVE.DesignFacade.handle(id, 'delete');
          replacementId = id;
        }

        INKIVE.DesignFacade.create('sticker', _.extend({
          sticker_id: $image.attr('id').split('-').pop(),
          thumb_src: $image.attr('src'),
          svg_url: $image.data('svgUrl'),
          is_external: !['photodexia'].includes($image.data('provider')),
          replacement_id: replacementId,
          placeholder: !!($(thumb).closest('[data-action=on_rootFrames]').length),
          is_icon: $(thumb).find('.item').data('icon')
        }, bboxData));
      }
    },

    // -- Tab worker end
    nowTab: function () {
      const id = this.$elem.find('[role=tabpanel].active').attr('id');
      return id
        ? '#' + id
        : null;
    },

    resize: function () {
      const nowTab = this.nowTab();

      if (nowTab) {
        this.initScroll($(nowTab));
        $(nowTab).find('div.thumbnail-wrapper:not(.no-resizable)').initThumb();
      }
    },

    getShutterstockImagePresent: function () {
      const images = $('#svgcontent').find('image');
      const ids = [];

      for (let i = 0; i < images.length; i++) {
        const $img = $(images[i]);

        $img.data('external_source') === INKIVE.C.SHUTTERSTOCK && ids.push({
          externalId: $img.data('external_id'),
          id: $img.attr('id')
        });
      }

      return ids.length
        ? ids
        : false;
    }
  };
};
